export const assessmentOptions = {
  legality: {
    all: {
      riskScore: [],
    },
    illegalityOfTheSector: {
      threat: [
        {
          label: {
            en: 'There is no legal framework to govern or regulate the sector',
            fr: "Il n'existe pas de cadre juridique pour régir ou réglementer le secteur",
          },
          value: 5,
        },
        {
          label: {
            en: 'A legal framework is being developped, but does not yet regulate the sector',
            fr: "Un cadre juridique est en cours d'élaboration, mais il ne régit pas encore le secteur",
          },
          value: 4,
        },
        {
          label: {
            en: 'A legal framework exists, but is neither actively implemented nor enforced',
            fr: "Un cadre juridique existe, mais n'est pas activement mis en œuvre ou appliqué",
          },
          value: 3,
        },
        {
          label: {
            en: 'A legal framework exists, is partially implemented and/or its enforcement by competent authorities is limited',
            fr: 'Un cadre juridique existe, il est partiellement mis en œuvre et/ou son application par les autorités compétentes est limitée',
          },
          value: 2,
        },
        {
          label: {
            en: 'A legal framework exists, is actively implemented and enforced by the competent authorities',
            fr: 'Un cadre juridique existe, il est activement mis en œuvre et appliqué par les autorités compétentes',
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious effect on tax revenues, security of individuals, and/or supply chain integrity',
            fr: "Effet néfaste sur les recettes fiscales, la sécurité des personnes et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on tax revenues, security of individuals, and/or supply chain integrity',
            fr: "Effet préjudiciable majeur sur les recettes fiscales, la sécurité des personnes et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on tax revenues, security of individuals, and/or supply chain integrity',
            fr: " Effet préjudiciable modéré sur les recettes fiscales, la sécurité des personnes et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on tax revenues, security of individuals, and/or supply chain integrity',
            fr: " Effet délétère limité sur les recettes fiscales, la sécurité des personnes et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on tax revenues, security of individuals, and/or supply chain integrity',
            fr: "Aucun effet néfaste sur les recettes fiscales, la sécurité des personnes et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 1,
        },
      ],
      vulnerability: [
        {
          label: {
            en: 'Stakeholders lack viable economic alternatives and lack awareness on mining operations regulation procedure',
            fr: "Les parties prenantes n'ont pas d'alternatives économiques viables et ne connaissent pas la procédure de réglementation des opérations minières",
          },
          value: 5,
        },
        {
          label: {
            en: 'Stakeholders are aware of mining operations regulation procedure but the operator and/or state authorities lack capacity to support it',
            fr: "Les parties prenantes connaissent la procédure de réglementation des opérations minières mais l'opérateur et/ou les autorités publiques n'ont pas la capacité de la soutenir",
          },
          value: 4,
        },
        {
          label: {
            en: 'The operator is in the process of regulating his/her mining operations but state authorities lack capacity to support it',
            fr: "L'opérateur est en train de réglementer ses opérations minières mais les autorités publiques n'ont pas la capacité de le soutenir",
          },
          value: 3,
        },
        {
          label: {
            en: "The operator's legal status is (partially) in good standing and/or state authorities fail to regularly conduct checks and on-site visits",
            fr: "Le statut juridique de l'opérateur est (partiellement) en règle et/ou les autorités publiques ne procèdent pas régulièrement à des contrôles et à des visites sur place",
          },
          value: 2,
        },
        {
          label: {
            en: "The operator's legal status is fully in order and/or its good standing is confirmed by state authorities' regular checks and on-site visits",
            fr: "Le statut juridique de l'opérateur est entièrement en règle et/ou sa bonne réputation est confirmée par les contrôles réguliers et les visites sur place des autorités publiques",
          },
          value: 1,
        },
      ],
    },
    illegalMiningOperations: {
      threat: [
        {
          label: {
            en: 'Criminal, institutionalised, illegal mining operations',
            fr: 'Opérations minières criminelles, institutionnalisées, illégales',
          },
          value: 5,
        },
        {
          label: {
            en: 'Clandestine, fraudulently legalised mining operations',
            fr: 'Opérations minières clandestines, frauduleusement légalisées',
          },
          value: 4,
        },
        {
          label: {
            en: 'Informal, unlicensed, insufficiently regulated mining operations',
            fr: 'Opérations minières informelles, non autorisées, insuffisamment réglementées',
          },
          value: 3,
        },
        {
          label: {
            en: 'Partially-organised, underground and/or undeclared household-level mining activities',
            fr: 'Activités minières partiellement organisées, souterraines et/ou non déclarées au niveau des ménages.',
          },
          value: 2,
        },
        {
          label: {
            en: 'Declared, formal, legal mining operations',
            fr: 'Activités minières déclarées, formelles et légales',
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious effect on tax revenues, security of individuals, and/or supply chain integrity',
            fr: "Effet néfaste sur les recettes fiscales, la sécurité des personnes et/ou l'intégrité de la chaîne d'approvisionnement.",
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on tax revenues, security of individuals, and/or supply chain integrity',
            fr: "Effet préjudiciable majeur sur les recettes fiscales, la sécurité des personnes et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on tax revenues, security of individuals, and/or supply chain integrity',
            fr: "Effet préjudiciable modéré sur les recettes fiscales, la sécurité des personnes et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on tax revenues, security of individuals, and/or supply chain integrity',
            fr: "Effet délétère limité sur les recettes fiscales, la sécurité des personnes et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 2,
        },
        {
          label: {
            en: 'No deleterious effect on tax revenues, security of individuals, and/or supply chain integrity',
            fr: "Aucun effet néfaste sur les recettes fiscales, la sécurité des personnes et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 1,
        },
      ],
      vulnerability: [
        {
          label: {
            en: 'Stakeholders lack viable economic alternatives and lack awareness on mining operations regulation procedure',
            fr: "Les parties prenantes n'ont pas d'alternatives économiques viables et ne connaissent pas la procédure de réglementation des opérations minières",
          },
          value: 5,
        },
        {
          label: {
            en: 'Stakeholders are aware of mining operations regulation procedure but the operator and/or state authorities lack capacity to support it',
            fr: "Les parties prenantes connaissent la procédure de réglementation des opérations minières mais l'opérateur et/ou les autorités publiques n'ont pas la capacité de la soutenir",
          },
          value: 4,
        },
        {
          label: {
            en: 'The operator is in the process of legalising mining operations but state authorities lack capacity to support it',
            fr: "L'opérateur est en train de réglementer ses opérations minières mais les autorités publiques n'ont pas la capacité de le soutenir",
          },
          value: 3,
        },
        {
          label: {
            en: "The operator's legal status is partially in good standing and/or state authorities fail to regularly conduct checks and on-site visits",
            fr: "Le statut juridique de l'opérateur est (partiellement) en règle et/ou les autorités publiques ne procèdent pas régulièrement à des contrôles et à des visites sur place",
          },
          value: 2,
        },
        {
          label: {
            en: "The operator's legal status is fully in order, which is confirmed by state authorities' regular checks and on-site visits",
            fr: "Le statut juridique de l'opérateur est entièrement en règle et/ou sa bonne réputation est confirmée par les contrôles réguliers et les visites sur place des autorités publiques",
          },
          value: 1,
        },
      ],
    },
    illegalSupplyChainActors: {
      threat: [
        {
          label: {
            en: 'Criminal, institutionalised, illegal supply chain actors',
            fr: "Acteurs de la chaîne d'approvisionnement criminels, institutionnalisés, illégaux",
          },
          value: 5,
        },
        {
          label: {
            en: 'Clandestine and fraudulent supply chain actors',
            fr: "Acteurs de la chaîne d'approvisionnement clandestins et frauduleux",
          },
          value: 4,
        },
        {
          label: {
            en: 'Informal, unlicensed, insufficiently regulated supply chain actors',
            fr: "Acteurs de la chaîne d'approvisionnement informels, non autorisés, insuffisamment réglementés",
          },
          value: 3,
        },
        {
          label: {
            en: 'Partially-organised, underground and household-level supply chain actors',
            fr: "Acteurs de la chaîne d'approvisionnement partiellement organisés, clandestins et au niveau des ménages",
          },
          value: 2,
        },
        {
          label: {
            en: 'Legal and formalised supply chain actors',
            fr: "Acteurs de la chaîne d'approvisionnement légaux et formalisés",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious effect on tax revenues, security of individuals, and/or supply chain integrity',
            fr: "Effet néfaste sur les recettes fiscales, la sécurité des personnes et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on tax revenues, security of individuals, and/or supply chain integrity',
            fr: "Effet préjudiciable majeur sur les recettes fiscales, la sécurité des personnes et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on tax revenues, security of individuals, and/or supply chain integrity',
            fr: "Effet préjudiciable modéré sur les recettes fiscales, la sécurité des personnes et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on tax revenues, security of individuals, and/or supply chain integrity',
            fr: "Effet délétère limité sur les recettes fiscales, la sécurité des personnes et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on tax revenues, security of individuals, and/or supply chain integrity',
            fr: "Aucun effet néfaste sur les recettes fiscales, la sécurité des personnes et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 1,
        },
      ],
      vulnerability: [
        {
          label: {
            en: 'Stakeholders lack viable economic alternatives and lack awareness of monitoring and/or background checks',
            fr: "Les parties prenantes n'ont pas d'alternatives économiques viables et ne sont pas sensibilisées au contrôle et/ou à la vérification des antécédents",
          },
          value: 5,
        },
        {
          label: {
            en: 'Stakeholders are aware of risk but are unable to monitor and/or run background checks on supply chain actors they do business with',
            fr: "Les parties prenantes sont conscientes du risque mais ne sont pas en mesure de surveiller et/ou de vérifier les antécédents des acteurs de la chaîne d'approvisionnement avec lesquels elles font des affaires",
          },
          value: 4,
        },
        {
          label: {
            en: 'Stakeholders can monitor and/or run background checks on supply chain actors they do business with, but cannot mitigate the risk',
            fr: "Les parties prenantes peuvent surveiller et/ou vérifier les antécédents des acteurs de la chaîne d'approvisionnement avec lesquels elles font des affaires, mais ne peuvent pas atténuer le risque",
          },
          value: 3,
        },
        {
          label: {
            en: 'Stakeholders can monitor and run background checks on supply chain actors they do business with, and mitigate the risk but with mixed results',
            fr: "Les parties prenantes peuvent surveiller et vérifier les antécédents des acteurs de la chaîne d'approvisionnement avec lesquels elles font des affaires, et atténuer le risque, mais avec des résultats mitigés",
          },
          value: 2,
        },
        {
          label: {
            en: 'Stakeholders can fully monitor and mitigate the risk through their background checks',
            fr: 'Les parties prenantes peuvent entièrement surveiller et atténuer le risque grâce à leurs vérifications des antécédents',
          },
          value: 1,
        },
      ],
    },
    contradictoryClaims: {
      threat: [
        {
          label: {
            en: 'High-intensity conflict(s) over mine, land and/or other contradictory claims',
            fr: "Conflit(s) de haute intensité concernant des mines, des terres et/ou d'autres revendications contradictoires",
          },
          description: {
            en: 'Manifest (acted upon) long-term differences involving non-negotiable issues',
            fr: 'Différends manifestes (auxquels on a donné suite), sur le long terme, et qui concernent des questions non négociables.',
          },
          value: 5,
        },
        {
          label: {
            en: 'Low-intensity conflict(s) over mine, land and/or other claims',
            fr: "Conflit(s) de faible intensité concernant des mines, des terres et/ou d'autres revendications contradictoires",
          },
          description: {
            en: 'Latent (not acted upon) long-term differences involving non-negotiable issues',
            fr: 'Différends latents (non traités), sur le long terme, et qui concernent des questions non négociables.',
          },
          value: 4,
        },
        {
          label: {
            en: 'High-intensity dispute(s) over mine, land and/or other claims',
            fr: "Litige(s) de forte intensité concernant les mines, les terres et/ou d'autres revendications contradictoires",
          },
          description: {
            en: 'Manifest (acted upon) short-term disagreements involving negotiable issues',
            fr: 'Désaccords manifestes (auxquels on a donné suite), sur le court terme, et qui concernent des questions négociables.',
          },
          value: 3,
        },
        {
          label: {
            en: 'Low-intensity dispute(s) over mine, land and/or other claims',
            fr: "Litige(s) de faible intensité concernant des mines, des terres et/ou d'autres revendications contradictoires",
          },
          description: {
            en: 'Latent (not acted upon) short-term disagreements involving negotiable issues',
            fr: 'Désaccords latents (non traités), sur le court terme, et qui concernent des questions négociables.',
          },
          value: 2,
        },
        {
          label: {
            en: 'No dispute over mine, land and/or other contradictory claims',
            fr: "Aucun différend concernant les mines, les terres et/ou d'autres revendications contradictoires",
          },
          description: {
            en: 'No latent or manifest, short-term or long-term disagreements involving (non-)negotiable issues',
            fr: 'Aucun désaccord latent ou manifeste, à court ou à long terme, portant sur des questions (non) négociables.v',
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Destructive and deadly disputes/conflicts between operators and third parties or local communities',
            fr: 'Disputes/conflits destructeurs et meurtriers entre les opérateurs et les tiers ou les communautés locales',
          },
          value: 5,
        },
        {
          label: {
            en: 'Major damage or harm caused by disputes/conflicts between operators and third parties or local communities',
            fr: 'Dommages ou préjudices importants causés par des différends/conflits entre des opérateurs et des tiers ou des communautés locales',
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate damage or harm caused by disputes/conflicts between operators and third parties or local communities',
            fr: 'Dommages ou préjudices modérés causés par des différends/conflits entre des opérateurs et des tiers ou des communautés locales',
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited damage or harm caused by disputes/conflicts between operators and third parties or local communities',
            fr: 'Dommages ou préjudices limités causés par des différends/conflits entre des opérateurs et des tiers ou des communautés locales',
          },
          value: 2,
        },
        {
          label: {
            en: 'No damage or harm caused by disputes/conflicts between operators and third parties or local communities',
            fr: 'Aucun dommage ou préjudice causé par des différends/conflits entre des opérateurs et des tiers ou des communautés locales',
          },
          value: 1,
        },
      ],
      vulnerability: [
        {
          label: {
            en: 'Complete risk exposure for stakeholders due to lack or insufficient awareness of state land regulation, administration and management tools',
            fr: "Exposition complète des parties prenantes aux risques en raison de l'absence ou de la méconnaissance des outils de l'État concernant la réglementation, l'administration et la gestion des terres",
          },
          description: {
            en: 'Lack of state regulation and standards and/or poor government communication around such regulation for land use surveying, registration, valuation, planning, construction, etc.',
            fr: "Absence de réglementation et de normes étatiques et/ou mauvaise communication du gouvernement concernant l'arpentage, l'enregistrement, l'évaluation, la planification, la construction, etc. de l'utilisation des terres.",
          },
          value: 5,
        },
        {
          label: {
            en: 'Major risk exposure for stakeholders, who are unable to verify contradictory claims when they arise',
            fr: "Exposition majeure aux risques pour les parties prenantes, qui ne sont pas en mesure de vérifier les affirmations contradictoires lorsqu'elles se produisent",
          },
          description: {
            en: 'State land regulation, administration and management tools do exist but local stakeholders lack the capacity, guidance and/or support to mobilise these resources to verify and settle contradictory claims.',
            fr: "Les outils publiques de réglementation, d'administration et de gestion des terres existent, mais les parties prenantes locales n'ont pas la capacité, les conseils et/ou le soutien nécessaires pour mobiliser ces ressources afin de vérifier et de régler les revendications contradictoires.",
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate risk exposure for stakeholders, who are able to verify contradictory claims but not to settle them',
            fr: 'Exposition modérée au risque pour les parties prenantes, qui sont en mesure de vérifier les revendications contradictoires mais pas de les régler',
          },
          description: {
            en: 'State land regulation, administration and management tools exist and are mobilised by local stakeholders to verify contradictory claims, but the competent state authorities are unable to enforce the law or court decisions to settle contradictory claims.',
            fr: "Les outils publiques de réglementation, d'administration et de gestion des terres existent et sont mobilisés par les parties prenantes locales pour vérifier les revendications contradictoires, mais les autorités publiques compétentes ne sont pas en mesure d'appliquer la loi ou les décisions de justice pour régler les revendications contradictoires.",
          },
          value: 3,
        },
        {
          label: {
            en: 'Minor risk exposure for stakeholders, who are able to verify contradictory claims and to settle them with mixed results',
            fr: 'Exposition mineure au risque pour les parties prenantes, qui sont en mesure de vérifier les revendications contradictoires et de les régler, avec des résultats mitigés',
          },
          description: {
            en: 'State land regulation, administration and management tools exist and are mobilised by local stakeholders to verify contradictory claims, but the law or court decisions made by the competent authorities are not always respected by involved parties.',
            fr: "Les outils publiques  de réglementation, d'administration et de gestion des terres existent et sont mobilisés par les parties prenantes locales pour vérifier les revendications contradictoires, mais la loi ou les décisions de justice prises par les autorités compétentes ne sont pas toujours respectées par les parties concernées.",
          },
          value: 2,
        },
        {
          label: {
            en: 'Stakeholders can fully monitor and mitigate the risk of unsettled contradictory claims',
            fr: 'Les parties prenantes peuvent surveiller et atténuer le risque de revendications contradictoires non réglées',
          },
          description: {
            en: 'State land regulation, administration and management tools do exist, local stakeholders are aware and provided with support to mobilise these resources to verify and settle contradictory claims, and competent authorities are able to enforce the law and court decisions.',
            fr: "Il existe des outils publiques de réglementation, d'administration et de gestion des terres, les parties prenantes locales sont sensibilisées et bénéficient d'un soutien pour mobiliser ces ressources afin de vérifier et de régler les revendications contradictoires, et les autorités compétentes sont en mesure de faire appliquer la loi et les décisions de justice.",
          },
          value: 1,
        },
      ],
    },
    missingEvidence: {
      threat: [
        {
          label: {
            en: 'Operators lack all legally valid public or private documents to authorise their operations',
            fr: ' Les opérateurs ne disposent pas de tous les documents publics ou privés légalement valables pour autoriser leurs opérations',
          },
          value: 5,
        },
        {
          label: {
            en: 'Operators lack most of legally valid public or private documents to authorize their operations',
            fr: 'Les opérateurs ne disposent pas de la plupart des documents publics ou privés légalement valides pour autoriser leurs opérations',
          },
          value: 4,
        },
        {
          label: {
            en: 'Operators hold some of legally valid public or private documents to authorize their operations',
            fr: 'Les opérateurs détiennent une partie des documents publics ou privés légalement valides pour autoriser leurs opérations',
          },
          value: 3,
        },
        {
          label: {
            en: 'Operators hold most of legally valid public or private documents to authorize their operations',
            fr: 'Les opérateurs détiennent la plupart des documents publics ou privés légalement valides pour autoriser leurs opérations',
          },
          value: 2,
        },
        {
          label: {
            en: 'Operators hold all legally valid public or private documents to authorize their operations',
            fr: 'Les opérateurs détiennent tous les documents publics ou privés légalement valides pour autoriser leurs opérations',
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious effect on transparency and tax revenues',
            fr: 'Effet néfaste sur la transparence et les recettes fiscales',
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on transparency and tax revenues',
            fr: 'Effet préjudiciable majeur sur la transparence et les recettes fiscales',
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on transparency and tax revenues',
            fr: 'Effet préjudiciable modéré sur la transparence et les recettes fiscales',
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on transparency and tax revenues',
            fr: 'Effet délétère limité sur la transparence et les recettes fiscales',
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on transparency and tax revenues',
            fr: 'Aucun effet néfaste sur la transparence et les recettes fiscales',
          },
          value: 1,
        },
      ],
      vulnerability: [
        {
          label: {
            en: 'Stakeholders face complete risk exposure due to lack of awareness of regulatory evidence required',
            fr: "Les parties prenantes sont totalement exposées au risque en raison de l'ignorance des preuves réglementaires requises",
          },
          value: 5,
        },
        {
          label: {
            en: 'Stakeholders are aware of the regulatory evidence required but lack the guidance and support to apply for it',
            fr: 'Les parties prenantes sont conscientes des preuves réglementaires requises mais ne disposent pas des conseils et du soutien nécessaires pour effectuer les démarches',
          },
          value: 4,
        },
        {
          label: {
            en: 'Stakeholders applied for their regulatory documents but face major/moderate issues regarding their validity, legitimicy and/or timely delivery by competent regulatory authorities',
            fr: 'Les parties prenantes ont demandé leurs documents réglementaires mais sont confrontées à des problèmes majeurs/modérés concernant leur validité, leur légitimité et/ou leur livraison en temps voulu par les autorités réglementaires compétentes',
          },
          value: 3,
        },
        {
          label: {
            en: 'Stakeholders applied for their regulatory documents but face minor issues regarding their validity, legitimicy and/or timely delivery by competent regulatory authorities',
            fr: 'Les parties prenantes ont demandé leurs documents réglementaires mais rencontrent des problèmes mineurs concernant leur validité, leur légitimité et/ou leur livraison en temps voulu par les autorités réglementaires compétentes.',
          },
          value: 2,
        },
        {
          label: {
            en: 'Stakeholders applied for and are in full possession of their regulatory documents, and face no issue regarding their validity, legitimicy and/or timely delivery',
            fr: 'Les parties prenantes ont demandé et sont en pleine possession de leurs documents réglementaires, et ne rencontrent aucun problème concernant leur validité, leur légitimité et/ou leur livraison en temps voulu.',
          },
          value: 1,
        },
      ],
    },
    moneyLaundering: {
      threat: [
        {
          label: {
            en: 'Pervasive cases of money laundering',
            fr: "Cas omniprésents de blanchiment d'argent",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread cases of money laundering',
            fr: "Cas généralisés de blanchiment d'argent",
          },
          value: 4,
        },
        {
          label: {
            en: 'Significant cases of money laundering',
            fr: 'Cas significatifs de blanchiment de capitaux',
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare cases of money laundering',
            fr: 'De rares cas de blanchiment de capitaux',
          },
          value: 2,
        },
        {
          label: {
            en: 'No case of money laundering',
            fr: 'Aucun cas de blanchiment de capitaux',
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious effect on financial flow control and tax revenues, which greatly benefits criminal activities',
            fr: 'Effet néfaste sur le contrôle des flux financiers et les recettes fiscales, qui profite largement aux activités criminelles',
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on financial flow control and tax revenues, which benefits criminal activities',
            fr: 'Effet préjudiciable majeur sur le contrôle des flux financiers et les recettes fiscales, qui profite aux activités criminelles',
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on financial flow control and tax revenues, which may benefit criminal activities',
            fr: 'Effet préjudiciable modéré sur le contrôle des flux financiers et les recettes fiscales, qui peut profiter aux activités criminelles',
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on financial flow control and tax revenues',
            fr: 'Effet délétère limité sur le contrôle des flux financiers et les recettes fiscales',
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on financial flow control and tax revenues',
            fr: 'Aucun effet négatif sur le contrôle des flux financiers et les recettes fiscales',
          },
          value: 1,
        },
      ],
      vulnerability: [
        {
          label: {
            en: 'Stakeholders lack awareness of the risk and/or lack access to formal sources of financing (e.g. banking system)',
            fr: "Les parties prenantes ne sont pas conscientes du risque et/ou n'ont pas accès aux sources de financement formelles (par exemple, le système bancaire)",
          },
          value: 5,
        },
        {
          label: {
            en: 'Stakeholders are aware of the risk but cannot monitor their transactions and/or lack access to formal sources of financing',
            fr: "Les parties prenantes sont conscientes du risque mais ne peuvent pas surveiller leurs transactions et/ou n'ont pas accès aux sources de financement formelles",
          },
          value: 4,
        },
        {
          label: {
            en: 'Stakeholders can monitor their transactions but cannot mitigate the risk and/or enjoy limited access to formal sources of financing',
            fr: 'Les parties prenantes peuvent surveiller leurs transactions mais ne peuvent pas atténuer le risque et/ou ont un accès limité aux sources formelles de financement',
          },
          value: 3,
        },
        {
          label: {
            en: 'Stakeholders can monitor their transactions and mitigate the risk but with mixed results and/or enjoy moderate access to formal sources of financing',
            fr: "Les parties prenantes peuvent surveiller leurs transactions et atténuer le risque, mais avec des résultats mitigés et/ou bénéficient d'un accès modéré aux sources de financement formelles",
          },
          value: 2,
        },
        {
          label: {
            en: 'Stakeholders can fully monitor and mitigate the risk and/or enjoy full access to formal sources of financing',
            fr: "Les parties prenantes peuvent surveiller et atténuer complètement le risque et/ou bénéficier d'un accès complet aux sources de financement formelles",
          },
          value: 1,
        },
      ],
    },
    issueWithGovernmentPayments: {
      threat: [
        {
          label: {
            en: 'Pervasive practice of tax fraud and/or payment issues to the government',
            fr: 'Pratique omniprésente de fraude fiscale et/ou de problèmes de paiement au gouvernement',
          },
          description: {
            en: '50% or more of production revenues are not declared to competent state authorities.',
            fr: "50% ou plus des revenus de la production ne sont pas déclarés aux autorités compétentes de l'Etat.",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread practice of tax fraud and/or payment issues to the government',
            fr: 'Pratique généralisée de la fraude fiscale et/ou de problèmes de paiement au gouvernement',
          },
          description: {
            en: '25-50% of production revenues are not declared to competent state authorities.',
            fr: "25-50% des revenus de la production ne sont pas déclarés aux autorités compétentes de l'État.",
          },
          value: 4,
        },
        {
          label: {
            en: 'Recurring practice of tax fraud and/or payment issues to the government',
            fr: 'Pratique récurrente de la fraude fiscale et/ou de problèmes de paiement au gouvernement',
          },
          description: {
            en: '10-25% of production revenues are not declared to competent state authorities.',
            fr: "10-25% des revenus de la production ne sont pas déclarés aux autorités compétentes de l'Etat.",
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare cases of tax fraud and/or payment issues to the government',
            fr: 'De rares cas de fraude fiscale et/ou de problèmes de paiement au gouvernement',
          },
          description: {
            en: '10% or less of production revenues are not declared to competent state authorities.',
            fr: "10% ou moins des revenus de la production ne sont pas déclarés aux autorités compétentes de l'État.",
          },
          value: 2,
        },
        {
          label: {
            en: 'No practice of tax fraud and/or payment issues to government',
            fr: 'Aucun cas de fraude fiscale et/ou de problèmes de paiement au gouvernement',
          },
          description: {
            en: 'All production revenues are fully disclosed and declared to competent state authorities.',
            fr: "Tous les revenus de la production sont entièrement divulgués et déclarés aux autorités compétentes de l'État.",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious effect on financial flow control and tax revenues, which greatly benefits criminal activities',
            fr: 'Effet néfaste sur le contrôle des flux financiers et les recettes fiscales, qui profite largement aux activités criminelles',
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on financial flow control and tax revenues, which benefits criminal activities',
            fr: 'Effet préjudiciable majeur sur le contrôle des flux financiers et les recettes fiscales, qui profite aux activités criminelles',
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on financial flow control and tax revenues, which may benefit criminal activities',
            fr: 'Effet préjudiciable modéré sur le contrôle des flux financiers et les recettes fiscales, qui peut profiter aux activités criminelles',
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on financial flow control and tax revenues',
            fr: 'Effet délétère limité sur le contrôle des flux financiers et les recettes fiscales',
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on financial flow control and tax revenues',
            fr: 'Aucun effet négatif sur le contrôle des flux financiers et les recettes fiscales',
          },
          value: 1,
        },
      ],
      vulnerability: [
        {
          label: {
            en: 'The sector lacks a regulatory framework for payments to government',
            fr: "Le secteur ne dispose pas d'un cadre réglementaire pour les paiements au gouvernement",
          },
          value: 5,
        },
        {
          label: {
            en: 'A regulatory framework for payments to government is in development, but does not yet regulate the sector',
            fr: "Un cadre réglementaire pour les paiements au gouvernement est en cours d'élaboration, mais ne régit pas encore le secteur",
          },
          value: 4,
        },
        {
          label: {
            en: 'A regulatory framework for payments to government exists, but is neither actively implemented nor enforced',
            fr: "Il existe un cadre réglementaire pour les paiements au gouvernement, mais il n'est ni activement mis en œuvre ni appliqué",
          },
          value: 3,
        },
        {
          label: {
            en: 'A regulatory framework for payments to government exists, is partially implemented and enforced by the competent authorities',
            fr: 'Un cadre réglementaire pour les paiements aux gouvernements existe, est partiellement mis en œuvre et appliqué par les autorités compétentes',
          },
          value: 2,
        },
        {
          label: {
            en: 'A regulatory framework for payments to government exists, is actively implemented and enforced by the competent authorities',
            fr: 'Un cadre réglementaire pour les paiements aux gouvernements existe, est activement mis en œuvre et appliqué par les autorités compétentes',
          },
          value: 1,
        },
      ],
    },
    extortion: {
      threat: [
        {
          label: {
            en: 'Systematic illegal taxation or extortion of money or minerals by operators, supply chain participants, government agents and/or others',
            fr: "Taxation ou extorsion illégale systématique d'argent ou de minéraux par des opérateurs, des participants à la chaîne d'approvisionnement, des agents gouvernementaux et/ou d'autres personnes",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread illegal taxation or extortion of money or minerals by operators, supply chain participants, government agents and/or others',
            fr: "Taxation ou extorsion illégale généralisée d'argent ou de minéraux par des opérateurs, des participants à la chaîne d'approvisionnement, des agents gouvernementaux et/ou d'autres personnes",
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate illegal taxation or extortion of money or minerals by operators, supply chain participants, government agents and/or others',
            fr: "Taxation illégale ou extorsion modérée d'argent ou de minéraux par des opérateurs, des participants à la chaîne d'approvisionnement, des agents du gouvernement et/ou d'autres personnes",
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare illegal taxation or extortion of money or minerals by operators, supply chain participants, government agents and/or others',
            fr: "Rare taxation ou extorsion illégale d'argent ou de minéraux par des opérateurs, des participants à la chaîne d'approvisionnement, des agents du gouvernement et/ou d'autres personnes",
          },
          value: 2,
        },
        {
          label: {
            en: 'No illegal taxation or extortion of money or minerals by operators, supply chain participants, government agents and/or others',
            fr: "Pas de taxation ou d'extorsion illégale d'argent ou de minéraux par des opérateurs, des participants à la chaîne d'approvisionnement, des agents du gouvernement et/ou d'autres personnes",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious effect on tax revenues, security of individuals, and/or supply chain integrity',
            fr: "Effet néfaste sur les recettes fiscales, la sécurité des personnes et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on tax revenues, security of individuals, and/or supply chain integrity',
            fr: "Effet préjudiciable majeur sur les recettes fiscales, la sécurité des personnes et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on tax revenues, security of individuals, and/or supply chain integrity',
            fr: "Effet préjudiciable modéré sur les recettes fiscales, la sécurité des personnes et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on tax revenues, security of individuals, and/or supply chain integrity',
            fr: "Effet délétère limité sur les recettes fiscales, la sécurité des personnes et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on tax revenues, security of individuals, and/or supply chain integrity',
            fr: "Aucun effet néfaste sur les recettes fiscales, la sécurité des personnes et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 1,
        },
      ],
      vulnerability: [
        {
          label: {
            en: 'Stakeholders lack awareness of their vulnerability to extortion and of existing protection and prevention mechanisms',
            fr: "Les parties prenantes n'ont pas conscience de leur vulnérabilité à l'extorsion et/ou connaissance des mécanismes de protection et de prévention existants",
          },
          value: 5,
        },
        {
          label: {
            en: 'Stakeholders are aware of their legal vulnerability to extortion but lack guidance and support as to how to address it',
            fr: "Les parties prenantes sont conscientes de leur vulnérabilité juridique à l'extorsion mais manquent de conseils et de soutien sur la manière d'y faire face",
          },
          value: 4,
        },
        {
          label: {
            en: 'Stakeholders have an anti-extortion internal policy in place but are not able to enforce it and/or prevent their exposure to extortion demands',
            fr: "Les parties prenantes ont mis en place une politique interne de lutte contre l'extorsion mais ne sont pas en mesure de la faire appliquer et/ou de prévenir leur exposition aux demandes d'extorsion",
          },
          value: 3,
        },
        {
          label: {
            en: 'Stakeholders have an anti-extortion internal policy in place, are able to partially enforce it, and most extortion complaints and/or allegations are acknowledged and resolved',
            fr: "Les parties prenantes ont mis en place une politique interne de lutte contre l'extorsion, sont en mesure de l'appliquer partiellement et la plupart des plaintes et/ou allégations d'extorsion sont reconnues et résolues",
          },
          value: 2,
        },
        {
          label: {
            en: 'Stakeholders have an anti-extortion internal policy in place, are able to fully enforce it, and extortion complaints and/or allegations are acknowledged and resolved',
            fr: "Les parties prenantes ont mis en place une politique interne de lutte contre l'extorsion, sont en mesure de l'appliquer pleinement et les plaintes et/ou allégations d'extorsion sont reconnues et résolues",
          },
          value: 1,
        },
      ],
    },
    presenceSecurityForces: {
      threat: [
        {
          label: {
            en: "Security providers fully ignore human rights and national laws and/or do not support the operator's security needs",
            fr: "Les prestataires de services de sécurité ignorent totalement les droits de l'homme et les lois nationales et/ou ne répondent pas aux besoins de l'opérateur en matière de sécurité",
          },
          value: 5,
        },
        {
          label: {
            en: "Security providers largely ignore human rights and national laws and/or generally do not support the operator's security needs",
            fr: "Les prestataires de services de sécurité ignorent largement les droits de l'homme et les lois nationales et/ou ne répondent généralement pas aux besoins de sécurité de l'opérateur",
          },
          value: 4,
        },
        {
          label: {
            en: "Security providers seldomly act in full respect of human rights and national laws and/or in support of the operator's security needs",
            fr: "Les prestataires de services de sécurité agissent parfois dans le plein respect des droits de l'homme et des lois nationales et/ou pour répondre aux besoins de sécurité de l'opérateur",
          },
          value: 3,
        },
        {
          label: {
            en: "Security providers mostly act in full respect of human rights and national laws and/or in support of the operator's security needs",
            fr: "Les prestataires de services de sécurité agissent le plus souvent dans le plein respect des droits de l'homme et des lois nationales et/ou pour répondre aux besoins de sécurité de l'opérateur",
          },
          value: 2,
        },
        {
          label: {
            en: "Security providers completely act in full respect of human rights and national laws and/or in support of the operator's security needs",
            fr: "Les prestataires de services de sécurité respectent totalement les droits de l'homme et les lois nationales et/ou répondent aux besoins de sécurité de l'opérateur",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious effect on the security and livelihood of individuals, and/or supply chain integrity',
            fr: "Effet néfaste sur la sécurité et les moyens de subsistance des individus, et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on the security and livelihood of individuals, and/or supply chain integrity',
            fr: "Effet préjudiciable majeur sur la sécurité et les moyens de subsistance des personnes et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on the security and livelihood of individuals, and/or supply chain integrity',
            fr: "Effet préjudiciable modéré sur la sécurité et les moyens de subsistance des individus, et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on the security and livelihood of individuals, and/or supply chain integrity',
            fr: "Effet délétère limité sur la sécurité et les moyens de subsistance des individus, et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on the security and livelihood of individuals, and/or supply chain integrity',
            fr: "Aucun effet négatif sur la sécurité et les moyens de subsistance des personnes et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 1,
        },
      ],
      vulnerability: [
        {
          label: {
            en: 'Stakeholders lack awareness of existing screening mechanisms to prevent risks when hiring security providers and/or to limit interferences by public security forces',
            fr: "Les parties prenantes ne connaissent pas les mécanismes de sélection existants pour prévenir les risques lors de l'embauche de prestataires de services de sécurité et/ou pour limiter les interférences des forces de sécurité publique",
          },
          value: 5,
        },
        {
          label: {
            en: 'Stakeholders are aware of security providers screening mechanisms and ways to limit public security forces interferences, but have no risk management plan in place',
            fr: "Les parties prenantes connaissent les mécanismes de sélection des prestataires de sécurité et les moyens de limiter les interférences des forces de sécurité publique, mais n'ont pas mis en place de plan de gestion des risques",
          },
          value: 4,
        },
        {
          label: {
            en: 'Stakeholders have a risk management plan in place to address potential interferences/tensions with security providers and/or public security forces, but are not able to enforce it',
            fr: "Les parties prenantes ont mis en place un plan de gestion des risques pour faire face aux interférences/tensions potentielles avec les prestataires de services de sécurité et/ou les forces de sécurité publique, mais ne sont pas en mesure de l'appliquer",
          },
          value: 3,
        },
        {
          label: {
            en: 'Stakeholders have a risk management plan in place to address potential interferences/tensions with security providers and/or public security forces, but can only partially enforce it',
            fr: "Les parties prenantes ont mis en place un plan de gestion des risques pour faire face aux interférences/tensions potentielles avec les fournisseurs de services de sécurité et/ou les forces de sécurité publique, mais ne sont que partiellement en mesure de l'appliquer",
          },
          value: 2,
        },
        {
          label: {
            en: 'Stakeholders have a risk management plan in place to address potential interferences/tensions with security providers and/or public security forces, and they are able to fully enforce it',
            fr: "Les parties prenantes ont mis en place un plan de gestion des risques pour faire face aux interférences/tensions potentielles avec les fournisseurs de services de sécurité et/ou les forces de sécurité publique, et elles sont en mesure de l'appliquer intégralement",
          },
          value: 1,
        },
      ],
    },
    illegalControl: {
      threat: [
        {
          label: {
            en: 'Pervasive illegal control',
            fr: 'Contrôle illégal omniprésent',
          },
          description: {
            en: 'All of the production activities are under illegal control by operators, public/private security forces, non-state armed groups or others',
            fr: "Toutes les activités de production sont sous le contrôle illégal d'opérateurs, de forces de sécurité publiques/privées, de groupes armés non étatiques ou autres.",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread illegal control',
            fr: 'Contrôle illégal généralisé',
          },
          description: {
            en: 'A major proportion of production activities are under illegal control by operators, public/private security forces, non-state armed groups or others',
            fr: "Une grande partie des activités de production est sous le contrôle illégal d'opérateurs, de forces de sécurité publiques/privées, de groupes armés non étatiques ou autres.",
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate illegal control',
            fr: 'Contrôle illégal modéré',
          },
          description: {
            en: 'A large proportion of production activities are under illegal control by operators, public/private security forces, non-state armed groups or others',
            fr: "Une partie significative des activités de production est sous le contrôle illégal d'opérateurs, de forces de sécurité publiques/privées, de groupes armés non étatiques ou autres.",
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare illegal control',
            fr: 'Contrôle illégal rare',
          },
          description: {
            en: 'A small proportion of production activities are under illegal control by operators, public/private security forces, non-state armed groups or others',
            fr: "Une faible proportion des activités de production est sous contrôle illégal d'opérateurs, de forces de sécurité publiques/privées, de groupes armés non étatiques ou autres.",
          },
          value: 2,
        },
        {
          label: {
            en: 'No illegal control',
            fr: 'Aucun contrôle illégal',
          },
          description: {
            en: 'No form of illegal control over production activities by operators, public/private security forces, non-state armed groups or others',
            fr: 'Aucune forme de contrôle illégal des activités de production par des opérateurs, des forces de sécurité publiques/privées, des groupes armés non étatiques ou autres.',
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious effect on tax revenues, security and livelihood of individuals, and/or supply chain integrity',
            fr: "Effet néfaste sur les recettes fiscales, la sécurité et les moyens de subsistance des personnes, et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on tax revenues, security and livelihood of individuals, and/or supply chain integrity',
            fr: "Effet préjudiciable majeur sur les recettes fiscales, la sécurité et les moyens de subsistance des personnes et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on tax revenues, security and livelihoods of individuals, and/or supply chain integrity',
            fr: "Effet préjudiciable modéré sur les recettes fiscales, la sécurité et les moyens de subsistance des personnes, et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on tax revenues, security and livelihoods of individuals, and/or supply chain integrity',
            fr: "Effet délétère limité sur les recettes fiscales, la sécurité et les moyens de subsistance des personnes, et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on tax revenues, security and livelihoods of individuals, and/or supply chain integrity',
            fr: "Aucun effet négatif sur les recettes fiscales, la sécurité et les moyens de subsistance des personnes, et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 1,
        },
      ],
      vulnerability: [
        {
          label: {
            en: 'Stakeholders are not aware of support they are entitled to from competent authorities to prevent illegal control of operations',
            fr: 'Les parties prenantes ne sont pas conscientes du soutien auquel elles ont droit de la part des autorités compétentes pour empêcher le contrôle illégal des opérations',
          },
          value: 5,
        },
        {
          label: {
            en: 'Stakeholders are aware of support they are entitled to from competent authorities to prevent illegal control of operations, but lack access and ressources',
            fr: "Les parties prenantes sont conscientes de l'aide à laquelle elles ont droit de la part des autorités compétentes pour prévenir le contrôle illégal des opérations, mais manquent de moyens pour y accéder",
          },
          value: 4,
        },
        {
          label: {
            en: 'Stakeholders have access and ressources, but can seldomly rely on support of competent authorities to prevent illegal control of operations',
            fr: 'Les parties prenantes disposent de moyens, mais ne peuvent que rarement compter sur le soutien des autorités compétentes pour empêcher le contrôle illégal des opérations',
          },
          value: 3,
        },
        {
          label: {
            en: 'Stakeholders have access and ressources and can generally rely on support of competent authorities to prevent illegal control of operations',
            fr: 'Les parties prenantes disposent de moyens et peuvent généralement compter sur le soutien des autorités compétentes pour prévenir le contrôle illégal des opérations',
          },
          value: 2,
        },
        {
          label: {
            en: 'Stakeholders have access and ressources and can fully rely on support of competent authorities to prevent illegal control of operations',
            fr: "Les parties prenantes disposent de moyens et peuvent compter sur le soutien des autorités compétentes pour empêcher le contrôle illégal d'opérations",
          },
          value: 1,
        },
      ],
    },
    illegalTrade: {
      threat: [
        {
          label: {
            en: 'Pervasive illegal trade',
            fr: 'Commerce illégal omniprésent',
          },
          description: {
            en: 'All of the trading activities performed by operators and/or others are illegal',
            fr: "Toutes les activités commerciales réalisées par les opérateurs et/ou d'autres personnes sont illégales.",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread illegal trade',
            fr: 'Commerce illégal généralisé',
          },
          description: {
            en: 'A major proportion of the trading activities performed by operators and/or others are illegal',
            fr: "Une grande partie des activités commerciales exercées par les opérateurs et/ou d'autres personnes sont illégales.",
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate illegal trade',
            fr: 'Commerce illégal modéré',
          },
          description: {
            en: 'A large proportion of the trading activities performed by operators and/or others are illegal',
            fr: "Une partie significative des activités commerciales exercées par les opérateurs et/ou d'autres personnes sont illégales.",
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare illegal trade',
            fr: 'Commerce illégal rare',
          },
          description: {
            en: 'A small proportion of the trading activities performed by operators and/or others are illegal',
            fr: "Une faible proportion des activités commerciales exercées par les opérateurs et/ou d'autres personnes sont illégales.",
          },
          value: 2,
        },
        {
          label: {
            en: 'No illegal trade',
            fr: 'Aucun commerce illégal',
          },
          description: {
            en: 'No form of illegal trade by operators  and/or others',
            fr: 'Aucune forme de commerce illégal de la part des opérateurs et/ou des autres',
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious effect on tax revenues, criminal organisations impunity, security and livelihood of individuals, and/or supply chain integrity',
            fr: "Effet néfaste sur les recettes fiscales, l'impunité des organisations criminelles, la sécurité et les moyens de subsistance des personnes, et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on tax revenues, criminal organisations impunity, security and livelihood of individuals, and/or supply chain integrity',
            fr: "Effet préjudiciable majeur sur les recettes fiscales, l'impunité des organisations criminelles, la sécurité et les moyens de subsistance des personnes et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on tax revenues, criminal organisations impunity, security and livelihoods of individuals, and/or supply chain integrity',
            fr: "Effet préjudiciable modéré sur les recettes fiscales, l'impunité des organisations criminelles, la sécurité et les moyens de subsistance des personnes, et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on tax revenues, criminal organisations impunity, security and livelihoods of individuals, and/or supply chain integrity',
            fr: "Effet délétère limité sur les recettes fiscales, l'impunité des organisations criminelles, la sécurité et les moyens de subsistance des personnes, et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on tax revenues, criminal organisations impunity, security and livelihoods of individuals, and/or supply chain integrity',
            fr: "Aucun effet néfaste sur les recettes fiscales, l'impunité des organisations criminelles, la sécurité et les moyens de subsistance des personnes et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 1,
        },
      ],
      vulnerability: [
        {
          label: {
            en: 'Stakeholders are not aware of the legal requirements to prevent illegal trade in their operations',
            fr: 'Les parties prenantes ne sont pas conscientes des exigences légales pour prévenir le commerce illégal dans leurs activités',
          },
          value: 5,
        },
        {
          label: {
            en: 'Stakeholders are aware of the support they are entitled to from competent authorities to prevent illegal trade in their operations, but lack access and ressources',
            fr: "Les parties prenantes sont conscientes de l'appui auquel elles ont droit de la part des autorités compétentes pour prévenir le commerce illégal dans leurs activités, mais manquent de moyens pour y parvenir",
          },
          value: 4,
        },
        {
          label: {
            en: 'Stakeholders have access and ressources, but can seldomly rely on the support of competent authorities to prevent illegal trade in their operations',
            fr: 'Les parties prenantes disposent de moyens, mais peuvent rarement compter sur le soutien des autorités compétentes pour prévenir le commerce illégal dans leurs activités',
          },
          value: 3,
        },
        {
          label: {
            en: 'Stakeholders have access and ressources and can generally rely on the support of competent authorities to prevent illegal trade in their operations',
            fr: 'Les parties prenantes disposent de moyens et peuvent généralement compter sur le soutien des autorités compétentes pour prévenir le commerce illégal dans leurs activités',
          },
          value: 2,
        },
        {
          label: {
            en: 'Stakeholders have access and ressources and can rely on the full support of competent authorities to prevent illegal trade in their operations',
            fr: 'Les parties prenantes disposent de moyens et peuvent compter sur le soutien total des autorités compétentes pour prévenir le commerce illégal dans leurs activités',
          },
          value: 1,
        },
      ],
    },
    corruption: {
      threat: [
        {
          label: {
            en: 'Pervasive corruption, bribery and facilitation both outside and within the organisation involving large sums / transactions',
            fr: "Corruption systématique, pots-de-vin et facilitation en dehors et au sein de l'organisation impliquant des sommes / transactions importantes",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread corruption, bribery and facilitation offers outside and/or within the organisation involving large sums / transactions',
            fr: "Corruption généralisée, pots-de-vin et offres de facilitation en dehors et/ou à l'intérieur de l'organisation impliquant des sommes/transactions importantes",
          },
          value: 4,
        },
        {
          label: {
            en: 'Frequent corruption, bribery and facilitation offers for routine services outside and/or within the organisation',
            fr: "Offres fréquentes de corruption, pots-de-vin et facilitation pour des services de routine en dehors et/ou au sein de l'organisation",
          },
          value: 3,
        },
        {
          label: {
            en: 'Occasional instances of corruption, bribery and facilitation outside the organisation',
            fr: "Cas occasionnels de corruption, pots-de-vin et facilitation en dehors de l'organisation",
          },
          value: 2,
        },
        {
          label: {
            en: 'No form of corruption, bribery and facilitation outside and/or within the organisation',
            fr: "Aucune forme de corruption, de pots-de-vin et de facilitation en dehors et/ou au sein de l'organisation",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious effect on tax revenues, security and livelihood of individuals, and/or supply chain integrity',
            fr: "Effet néfaste sur les recettes fiscales, la sécurité et les moyens de subsistance des personnes, et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on tax revenues, security and livelihood of individuals, and/or supply chain integrity',
            fr: "Effet préjudiciable majeur sur les recettes fiscales, la sécurité et les moyens de subsistance des personnes et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on tax revenues, security and livelihoods of individuals, and/or supply chain integrity',
            fr: "Effet préjudiciable modéré sur les recettes fiscales, la sécurité et les moyens de subsistance des personnes, et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on tax revenues, security and livelihoods of individuals, and/or supply chain integrity',
            fr: "Effet délétère limité sur les recettes fiscales, la sécurité et les moyens de subsistance des personnes, et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on tax revenues, security and livelihoods of individuals, and/or supply chain integrity',
            fr: "Aucun effet négatif sur les recettes fiscales, la sécurité et les moyens de subsistance des personnes, et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 1,
        },
      ],
      vulnerability: [
        {
          label: {
            en: 'Stakeholders lack awareness of, or are denied, support from competent authorities to prevent corruption, bribery and facilitation',
            fr: 'Les parties prenantes ignorent ou se voient refuser le soutien des autorités compétentes pour prévenir la corruption, les pots-de-vin et la facilitation',
          },
          description: {
            en: 'They are not aware of the official channels to use to report, investigate and/or prevent cases of corruption, bribery and facilitation.',
            fr: 'Elles ne connaissent pas les canaux officiels à utiliser pour signaler, enquêter et/ou prévenir les cas de corruption, de pots-de-vin et de facilitation.',
          },
          value: 5,
        },
        {
          label: {
            en: 'Stakeholders are aware of the support they are entitled to from competent authorities but have no compliance programme',
            fr: "Les parties prenantes sont conscientes du soutien auquel elles ont droit de la part des autorités compétentes mais n'ont pas de programme de conformité",
          },
          description: {
            en: 'They are aware of the existing official channels to report, investigate and/or prevent cases of corruption, bribery and facilitation, but lack guidance and support to develop a compliance programme',
            fr: 'Elles connaissent les canaux officiels existants pour signaler, enquêter et/ou prévenir les cas de corruption, de pots-de-vin et de facilitation, mais manquent de conseils et de soutien pour développer un programme de conformité.',
          },
          value: 4,
        },
        {
          label: {
            en: 'Stakeholders have a compliance programme in place, but are not able to enforce it',
            fr: 'Les parties prenantes ont mis en place un programme de conformité, mais ne sont pas en mesure de le faire appliquer',
          },
          description: {
            en: 'They have the capacity to report and partially investigate cases of corruption, bribery and facilitation, but not to prevent them.',
            fr: "Elles ont la capacité de signaler et d'enquêter partiellement sur les cas de corruption, de pots-de-vin et de facilitation, mais pas de les prévenir.",
          },
          value: 3,
        },
        {
          label: {
            en: 'Stakeholders have a compliance programme in place, but can only partially enforce it',
            fr: "Les parties prenantes ont mis en place un programme de conformité, mais ne sont que partiellement en mesure de l'appliquer",
          },
          description: {
            en: 'They have the capacity to report, investigate and prevent cases of corruption, bribery and facilitation, but with mixed results.',
            fr: "Elles ont la capacité de signaler, d'enquêter et de prévenir les cas de corruption, de pots-de-vin et de facilitation, mais avec des résultats mitigés.",
          },
          value: 2,
        },
        {
          label: {
            en: 'Stakeholders have an effectively designed, implemented, and managed compliance programme',
            fr: "Les parties prenantes disposent d'un programme de conformité conçu, mis en œuvre et géré efficacement",
          },
          description: {
            en: 'They have full capacity to report, investigate and prevent cases of corruption, bribery and facilitation. A whisteblower program is made available to employees.',
            fr: "Elles ont la pleine capacité de signaler, d'enquêter et de prévenir les cas de corruption, de pots-de-vin et de facilitation. Un mécanisme de réclamation anonyme est mis à la disposition des employés.",
          },
          value: 1,
        },
      ],
    },
    contamination: {
      threat: [
        {
          label: {
            en: 'Pervasive supply chain contamination',
            fr: "Contamination systématique de la chaîne d'approvisionnement",
          },
          description: {
            en: '50% or more of handled products originate from unidentified or illegitimate sources.',
            fr: '50% ou plus des produits manipulés proviennent de sources non identifiées ou illégitimes.',
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread supply chain contamination',
            fr: "Contamination généralisée de la chaîne d'approvisionnement",
          },
          description: {
            en: '25-50% of handled products originate from unidentified or illegitimate sources.',
            fr: '25-50% des produits manipulés proviennent de sources non identifiées ou illégitimes.',
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate supply chain contamination',
            fr: "Contamination modérée de la chaîne d'approvisionnement",
          },
          description: {
            en: '10-25% of handled products originate from unidentified or illegitimate sources.',
            fr: '10-25% des produits manipulés proviennent de sources non identifiées ou illégitimes.',
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare supply chain contamination',
            fr: "Contamination rare de la chaîne d'approvisionnement",
          },
          description: {
            en: '10% or less of handled products originate from unidentified or illegitimate sources.',
            fr: '10% ou moins des produits manipulés proviennent de sources non identifiées ou illégitimes.',
          },
          value: 2,
        },
        {
          label: {
            en: 'No supply chain contamination',
            fr: "Aucune contamination de la chaîne d'approvisionnement",
          },
          description: {
            en: '100% of handled products originate from legitimately identified sources.',
            fr: 'Tous les produits manipulés proviennent de sources légitimement identifiées.',
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious effect on tax revenues, security and livelihood of individuals, and/or supply chain integrity',
            fr: "Effet néfaste sur les recettes fiscales, la sécurité et les moyens de subsistance des personnes, et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on tax revenues, security and livelihood of individuals, and/or supply chain integrity',
            fr: "Effet préjudiciable majeur sur les recettes fiscales, la sécurité et les moyens de subsistance des personnes et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on tax revenues, security and livelihoods of individuals, and/or supply chain integrity',
            fr: "Effet préjudiciable modéré sur les recettes fiscales, la sécurité et les moyens de subsistance des personnes, et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on tax revenues, security and livelihoods of individuals, and/or supply chain integrity',
            fr: "Effet délétère limité sur les recettes fiscales, la sécurité et les moyens de subsistance des personnes, et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on tax revenues, security and livelihoods of individuals, and/or supply chain integrity',
            fr: "Aucun effet négatif sur les recettes fiscales, la sécurité et les moyens de subsistance des personnes, et/ou l'intégrité de la chaîne d'approvisionnement",
          },
          value: 1,
        },
      ],
      vulnerability: [
        {
          label: {
            en: 'Stakeholders lack awareness of the issue',
            fr: 'Les parties prenantes ne sont pas conscientes du problème',
          },
          value: 5,
        },
        {
          label: {
            en: 'Stakeholders are aware of risk but are not able to monitor it',
            fr: 'Les parties prenantes sont conscientes du risque mais ne sont pas en mesure de le contrôler',
          },
          value: 4,
        },
        {
          label: {
            en: 'Stakeholders can monitor but not mitigate risk',
            fr: "Les parties prenantes peuvent surveiller le risque, mais pas l'atténuer",
          },
          value: 3,
        },
        {
          label: {
            en: 'Stakeholders can monitor and mitigate risk but with mixed results',
            fr: 'Les parties prenantes peuvent surveiller et atténuer le risque, mais avec des résultats mitigés',
          },
          value: 2,
        },
        {
          label: {
            en: 'Stakeholders can fully monitor and mitigate risk',
            fr: 'Les parties prenantes peuvent pleinement surveiller et atténuer le risque',
          },
          value: 1,
        },
      ],
    },
  },
  humanRights: {
    all: {
      vulnerability: [
        {
          label: {
            en: 'Stakeholders lack awareness of the issue',
            fr: 'Les parties prenantes ne sont pas conscientes du problème',
          },
          value: 5,
        },
        {
          label: {
            en: 'Stakeholders are aware of risk but are not able to monitor it',
            fr: 'Les parties prenantes sont conscientes du risque mais ne sont pas en mesure de le contrôler',
          },
          value: 4,
        },
        {
          label: {
            en: 'Stakeholders can monitor but not mitigate risk',
            fr: "Les parties prenantes peuvent surveiller le risque, mais pas l'atténuer",
          },
          value: 3,
        },
        {
          label: {
            en: 'Stakeholders can monitor and mitigate risk but with mixed results',
            fr: 'Les parties prenantes peuvent surveiller et atténuer le risque, mais avec des résultats mitigés',
          },
          value: 2,
        },
        {
          label: {
            en: 'Stakeholders can fully monitor and mitigate risk',
            fr: 'Les parties prenantes peuvent pleinement surveiller et atténuer le risque',
          },
          value: 1,
        },
      ],
      riskScore: [],
    },
    torture: {
      threat: [
        {
          label: {
            en: 'Systematic practice of torture',
            fr: 'Pratique systématique de la torture',
          },
          description: {
            en: 'Cases of torture in the workplace and its surroundings affect (over) 50% of the workforce.',
            fr: "Les cas de torture sur le lieu de travail et dans son environnement touchent (plus de) 50% de la main d'oeuvre.",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread practice of torture',
            fr: 'Pratique généralisée de la torture',
          },
          description: {
            en: 'Cases of torture in the workplace and its surroundings affect 25-50% of the workforce.',
            fr: "Les cas de torture sur le lieu de travail et dans son environnement touchent entre 25-50% de la main d'oeuvre.",
          },
          value: 4,
        },
        {
          label: {
            en: 'Large practice of torture',
            fr: 'Pratique importante de la torture',
          },
          description: {
            en: 'Cases of torture in the workplace and its surroundings affect 10-25% of the workforce.',
            fr: "Les cas de torture sur le lieu de travail et dans son environnement touchent entre 10-25% de la main d'oeuvre.",
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare cases of torture',
            fr: 'De rares cas de torture',
          },
          description: {
            en: 'Cases of torture in the workplace and its surroundings affect (less than) 10% of the workforce.',
            fr: "Les cas de torture sur le lieu de travail et dans son environnement touchent (moins de) 10% de la main d'oeuvre.",
          },
          value: 2,
        },
        {
          label: {
            en: 'No cases of torture',
            fr: 'Pas de cas de torture',
          },
          description: {
            en: 'No cases of torture in the workplace and its surroundings were identified.',
            fr: "Aucun cas de torture sur le lieu de travail et dans ses environs n'a été identifié.",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Dangerous and lethal impact on human rights standards and working conditions',
            fr: "Impact dangereux et mortel en matière de droits de l'homme et des normes de conditions de travail",
          },
          description: {
            en: "Torture cases by superiors put workers' dignity, security, and health at risk, and their life in peril.",
            fr: 'Les cas de torture par les supérieurs mettent en danger la dignité, la sécurité et la santé des travailleurs, ainsi que leur vie.',
          },
          value: 5,
        },
        {
          label: {
            en: 'Dangerous impact on human rights standards and working conditions',
            fr: "Impact dangereux en matière de droits de l'homme et des normes de conditions de travail",
          },
          description: {
            en: "Torture cases by superiors put workers' dignity, security, and health at risk.",
            fr: 'Les cas de torture par les supérieurs mettent en danger la dignité, la sécurité et la santé des travailleurs.',
          },
          value: 4,
        },
        {
          label: {
            en: 'Sub-standard human rights standards and working conditions',
            fr: "Droits de l'homme et normes de conditions de travail inférieures à la norme",
          },
          description: {
            en: "Torture cases by superiors put workers' dignity and health at risk.",
            fr: 'Les cas de torture par les supérieurs mettent en danger la dignité et la santé des travailleurs.',
          },
          value: 3,
        },
        {
          label: {
            en: 'Minor negative impact on human rights standards and working conditions',
            fr: "Impact négatif mineur en matière de droits de l'homme et des normes de conditions de travail",
          },
          description: {
            en: "Torture cases by superiors can put workers' dignity and / or health at risk.",
            fr: 'Les cas de torture par les supérieurs peuvent mettre en danger la dignité et/ou la santé des travailleurs.',
          },
          value: 2,
        },
        {
          label: {
            en: 'No negative impact on human rights standards and working conditions',
            fr: "Aucun impact négatif en matière de droits de l'homme et des normes de conditions de travail",
          },
          description: {
            en: "Cases of torture, if found to exist, do not put workers' dignity, health, security or life at risk.",
            fr: "Les cas de torture, s'ils sont avérés, ne mettent pas en danger la dignité, la santé, la sécurité ou la vie des travailleurs.",
          },
          value: 1,
        },
      ],
    },
    cruel: {
      threat: [
        {
          label: {
            en: 'Systematic practice of cruel, inhuman, or degrading treatment or punishment',
            fr: 'Pratique systématique de traitement cruel, inhumain et dégradant',
          },
          description: {
            en: 'Acts of cruel, inhuman, or degrading treatment or punishment in the workplace and its surroundings affect (over) 50% of the workforce.',
            fr: "Les cas de traitement cruel, inhumain et dégradant sur le lieu de travail et dans son environnement touchent (plus de) 50% de la main d'oeuvre.",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread practice of cruel, inhuman, or degrading treatment or punishment',
            fr: 'Pratique généralisée de traitement cruel, inhumain et dégradant',
          },
          description: {
            en: 'Cases of cruel, inhuman, or degrading treatment or punishment in the workplace and its surroundings affect 25-50% of the workforce.',
            fr: "Les cas de traitement cruel, inhumain et dégradant sur le lieu de travail et dans son environnement touchent 25-50% de la main d'oeuvre.",
          },
          value: 4,
        },
        {
          label: {
            en: 'Large practice of cruel, inhuman, or degrading treatment or punishment',
            fr: 'Pratique importante de traitement cruel, inhumain et dégradant',
          },
          description: {
            en: 'Cases of cruel, inhuman, or degrading treatment or punishment in the workplace and its surroundings affect 10-25% of the workforce.',
            fr: "Les cas de traitement cruel, inhumain et dégradant sur le lieu de travail et dans son environnement touchent 10-25% de la main d'oeuvre.",
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare cases of cruel, inhuman, or degrading treatment or punishment',
            fr: 'De rares cas de traitement cruel, inhumain et dégradant',
          },
          description: {
            en: 'Cases of cruel, inhuman, or degrading treatment or punishment in the workplace and its surroundings affect (less than) 10% of the workforce.',
            fr: "Les cas de traitement cruel, inhumain et dégradant sur le lieu de travail et dans son environnement touchent (moins de) 10% de la main d'oeuvre.",
          },
          value: 2,
        },
        {
          label: {
            en: 'No case of cruel, inhuman, or degrading treatment or punishment',
            fr: 'No case of cruel, inhuman, or degrading treatment or punishment',
          },
          description: {
            en: 'No cases of cruel, inhuman, or degrading treatment or punishment in the workplace or its surroundings were identified.',
            fr: "Aucun cas de traitement cruel, inhumain et dégradant sur le lieu de travail et dans ses environs n'a été identifié.",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Dangerous and lethal impact on human rights standards and working conditions',
            fr: "Impact dangereux et mortel en matière de droits de l'homme et des normes de conditions de travail",
          },
          description: {
            en: "Ill treatment by superiors puts workers' dignity, security, and health at risk, and their life in peril.",
            fr: 'Les mauvais traitements par les supérieurs mettent en danger la dignité, la sécurité et la santé des travailleurs, ainsi que leur vie.',
          },
          value: 5,
        },
        {
          label: {
            en: 'Dangerous impact on human rights standards and working conditions',
            fr: "Impact dangereux en matière de droits de l'homme et des normes de conditions de travail",
          },
          description: {
            en: "Ill treatment by superiors puts workers' dignity, security, and health at risk.",
            fr: 'Les mauvais traitements par les supérieurs mettent en danger la dignité, la sécurité et la santé des travailleurs.',
          },
          value: 4,
        },
        {
          label: {
            en: 'Sub-standard human rights standards and working conditions',
            fr: "Droits de l'homme et normes de conditions de travail inférieures à la norme",
          },
          description: {
            en: "Ill treatment by superiors puts workers' dignity and health at risk.",
            fr: 'Les mauvais traitements par les supérieurs mettent en danger la dignité et la santé des travailleurs.',
          },
          value: 3,
        },
        {
          label: {
            en: 'Minor negative impact on human rights standards and working conditions',
            fr: "Impact négatif mineur en matière de droits de l'homme et des normes de conditions de travail",
          },
          description: {
            en: "Ill treatment by superiors can put workers' dignity and / or health at risk.",
            fr: 'Les mauvais traitements par les supérieurs peuvent mettre en danger la dignité et/ou la santé des travailleurs.',
          },
          value: 2,
        },
        {
          label: {
            en: 'No negative impact on human rights standards and working conditions',
            fr: "Aucun impact négatif en matière de droits de l'homme et des normes de conditions de travail",
          },
          description: {
            en: "Cases of cruel, inhuman, or degrading treatment or punishment, if found to exist, do not put workers' dignity, health, security or life at risk.",
            fr: "Les mauvais traitements, s'ils sont avérés, ne mettent pas en danger la dignité, la santé, la sécurité ou la vie des travailleurs.",
          },
          value: 1,
        },
      ],
    },
    abusiveDisciplinary: {
      threat: [
        {
          label: {
            en: 'Systematic practice of abusive disciplinary practices',
            fr: 'Pratique systématique de mesures disciplinaires abusives',
          },
          description: {
            en: 'Emotionally abusive disciplinary behaviours and corporal punishment in the workplace and its surroundings affect (over) 50% of the workforce.',
            fr: "Les comportements disciplinaires abusifs sur le plan émotionnel et châtiments corporels sur le lieu de travail et dans son environnement touchent (plus de) 50% de la main d'oeuvre.",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread practice of abusive disciplinary practices',
            fr: 'Pratique généralisée de mesures disciplinaires abusives',
          },
          description: {
            en: 'Emotionally abusive disciplinary behaviours and corporal punishment in the workplace and its surroundings affect 25-50% of the workforce.',
            fr: "Les comportements disciplinaires abusifs sur le plan émotionnel et châtiments corporels sur le lieu de travail et dans son environnement touchent 25-50% de la main d'oeuvre.",
          },
          value: 4,
        },
        {
          label: {
            en: 'Large practice of cruel, inhuman, or degrading treatment or punishment',
            fr: 'Pratique importante de mesures disciplinaires abusives',
          },
          description: {
            en: 'Emotionally abusive disciplinary behaviours and corporal punishment in the workplace and its surroundings affect 10-25% of the workforce.',
            fr: "Les comportements disciplinaires abusifs sur le plan émotionnel et châtiments corporels sur le lieu de travail et dans son environnement touchent 10-25% de la main d'oeuvre.",
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare cases of abusive disciplinary practices',
            fr: 'De rares cas de mesures disciplinaires abusives',
          },
          description: {
            en: 'Emotionally abusive disciplinary behaviours and corporal punishment in the workplace and its surroundings affect (less than) 10% of the workforce.',
            fr: "Les comportements disciplinaires abusifs sur le plan émotionnel et châtiments corporels sur le lieu de travail et dans son environnement touchent (moins de) 10% de la main d'oeuvre.",
          },
          value: 2,
        },
        {
          label: {
            en: 'No case of abusive disciplinary practice',
            fr: 'Pas de cas de mesures disciplinaires abusives',
          },
          description: {
            en: 'No case of emotionally abusive disciplinary behaviour and corporal punishment in the workplace and its surroundings were identified at the workplace and its surroundings.',
            fr: "Aucun comportement disciplinaire abusif sur le plan émotionnel et châtiment corporel sur le lieu de travail et dans ses environs n'ont été identifié.",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Dangerous and lethal impact on human rights standards and working conditions',
            fr: "Impact dangereux et mortel en matière de droits de l'homme et des normes de conditions de travail",
          },
          description: {
            en: "Abusive disciplinary practices by superiors instill fear among the workforce and can put workers' dignity, security, and health at risk, and their life in peril.",
            fr: 'Les pratiques disciplinaires abusives par les supérieurs mettent en danger la dignité, la sécurité et la santé des travailleurs, ainsi que leur vie.',
          },
          value: 5,
        },
        {
          label: {
            en: 'Dangerous impact on human rights standards and working conditions',
            fr: "Impact dangereux en matière de droits de l'homme et des normes de conditions de travail",
          },
          description: {
            en: "Abusive disciplinary practices by superiors instill fear among the workforce and can put workers' dignity, security, and health at risk.",
            fr: 'Les pratiques disciplinaires abusives par les supérieurs mettent en danger la dignité, la sécurité et la santé des travailleurs.',
          },
          value: 4,
        },
        {
          label: {
            en: 'Sub-standard human rights standards and working conditions',
            fr: "Droits de l'homme et normes de conditions de travail inférieures à la norme",
          },
          description: {
            en: "Abusive disciplinary practices by superiors instill fear among the workforce and can put workers' dignity and health at risk.",
            fr: 'Les pratiques disciplinaires abusives par les supérieurs mettent en danger la dignité et la santé des travailleurs.',
          },
          value: 3,
        },
        {
          label: {
            en: 'Minor negative impact on human rights standards and working conditions',
            fr: "Impact négatif mineur en matière de droits de l'homme et des normes de conditions de travail",
          },
          description: {
            en: 'Abusive disciplinary practices by superiors can instill fear among the workforce.',
            fr: 'Les pratiques disciplinaires abusives par les supérieurs peuvent mettre en danger la dignité et/ou la santé des travailleurs.',
          },
          value: 2,
        },
        {
          label: {
            en: 'No negative impact on human rights standards and working conditions',
            fr: "Aucun impact négatif en matière de droits de l'homme et des normes de conditions de travail",
          },
          description: {
            en: "Cases of emotionally abusive disciplinary behaviour and corporal punishment, if found to exist, do not put workers' dignity, health, security or life at risk.",
            fr: 'Les pratiques disciplinaires abusives, si elles sont avérées, ne mettent pas en danger la dignité, la santé, la sécurité ou la vie des travailleurs.',
          },
          value: 1,
        },
      ],
    },
    discrimination: {
      threat: [
        {
          label: {
            en: 'Systematic practice of discrimination',
            fr: 'Pratique systématique de discrimination',
          },
          description: {
            en: 'Discrimination and unequal treatment in the workplace and its surroundings affect (over) 50% of the workforce.',
            fr: "La discrimination et le traitement inégal sur le lieu de travail et dans son environnement touchent (plus de) 50% de la main d'oeuvre.",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread practice of discrimination',
            fr: 'Pratique généralisée de discrimintation',
          },
          description: {
            en: 'Discrimination and unequal treatment in the workplace and its surroundings affect 25-50% of the workforce.',
            fr: "La discrimination et le traitement inégal sur le lieu de travail et dans son environnement touchent 25-50% de la main d'oeuvre.",
          },
          value: 4,
        },
        {
          label: {
            en: 'Large practice of discrimination',
            fr: 'Pratique importante de discrimination',
          },
          description: {
            en: 'Discrimination and unequal treatment in the workplace and its surroundings affect 10-25% of the workforce.',
            fr: "La discrimination et le traitement inégal sur le lieu de travail et dans son environnement touchent 10-25% de la main d'oeuvre.",
          },
          value: 3,
        },
        {
          label: {
            en: 'Minor practice of discrimination',
            fr: 'De rares cas de discrimination',
          },
          description: {
            en: 'Discrimination and unequal treatment in the workplace and its surroundings affect (less than) 10% of the workforce.',
            fr: "La discrimination et le traitement inégal sur le lieu de travail et dans son environnement touchent (moins de) 10% de la main d'oeuvre.",
          },
          value: 2,
        },
        {
          label: {
            en: 'No case of discrimination',
            fr: 'Pas de cas de discrimination',
          },
          description: {
            en: 'No case of discrimination or unequal treatment at the workplace or its surroundings were identified.',
            fr: "Aucune discrimination et traitement inégal sur le lieu de travail et dans ses environs n'ont été identifié.",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Dangerous and lethal impact on human rights standards and working conditions',
            fr: "Impact dangereux et mortel en matière de droits de l'homme et des normes de conditions de travail",
          },
          description: {
            en: "Discrimination and unequal treatment puts workers' dignity, security, and health at risk, and their life in peril.",
            fr: 'La discrimination et le traitement inégal par les supérieurs mettent en danger la dignité, la sécurité et la santé des travailleurs, ainsi que leur vie.',
          },
          value: 5,
        },
        {
          label: {
            en: 'Dangerous impact on human rights standards and working conditions',
            fr: "Impact dangereux en matière de droits de l'homme et des normes de conditions de travail",
          },
          description: {
            en: "Discrimination and unequal treatment puts workers' dignity, security, and health at risk.",
            fr: 'La discrimination et le traitement inégal par les supérieurs mettent en danger la dignité, la sécurité et la santé des travailleurs.',
          },
          value: 4,
        },
        {
          label: {
            en: 'Sub-standard human rights standards and working conditions',
            fr: "Droits de l'homme et normes de conditions de travail inférieures à la norme",
          },
          description: {
            en: "Discrimination and unequal treatment puts workers' dignity and health at risk.",
            fr: 'La discrimination et le traitement inégal par les supérieurs mettent en danger la dignité et la santé des travailleurs.',
          },
          value: 3,
        },
        {
          label: {
            en: 'Minor negative impact on human rights standards and working conditions',
            fr: "Impact négatif mineur en matière de droits de l'homme et des normes de conditions de travail",
          },
          description: {
            en: "Discrimination and unequal treatment can put workers' dignity at risk.",
            fr: 'La discrimination et le traitement inégal par les supérieurs peuvent mettre en danger la dignité et/ou la santé des travailleurs.',
          },
          value: 2,
        },
        {
          label: {
            en: 'No negative impact on human rights standards and working conditions',
            fr: "Aucun impact négatif en matière de droits de l'homme et des normes de conditions de travail",
          },
          description: {
            en: "Cases of discrimination and unequal treatment, if found to exist, do not put workers' dignity, health, security or life at risk.",
            fr: "Cases of discrimination and unequal treatment, if found to exist, do not put workers' dignity, health, security or life at risk.",
          },
          value: 1,
        },
      ],
    },
    forcedLabour: {
      threat: [
        {
          label: {
            en: 'Systematic practice of forced labour',
            fr: 'Pratique systématique du travail forcé',
          },
          description: {
            en: 'Victims of forced labour make up for 50% or more of total workforce.',
            fr: "Le travail forcé sur le lieu de travail et dans son environnement touchent (plus de) 50% de la main d'oeuvre.",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread practice of forced labour',
            fr: 'Pratique généralisée du travail forcé',
          },
          description: {
            en: 'Victims of forced labour make up for 25-50% of total workforce.',
            fr: "Le travail forcé sur le lieu de travail et dans son environnement touchent 25-50% de la main d'oeuvre.",
          },
          value: 4,
        },
        {
          label: {
            en: 'Large practice of forced labour',
            fr: 'Pratique importante du travail forcé',
          },
          description: {
            en: 'Victims of forced labour make up for 10-25% of total workforce.',
            fr: "Le travail forcé sur le lieu de travail et dans son environnement touchent 10-25% de la main d'oeuvre.",
          },
          value: 3,
        },
        {
          label: {
            en: 'Minor practice of forced labour',
            fr: 'De rares cas de travail forcé',
          },
          description: {
            en: 'Victims of forced labour make up for (less than) 10% of total workforce.',
            fr: "Le travail forcé sur le lieu de travail et dans son environnement touchent (moins de) 10% de la main d'oeuvre.",
          },
          value: 2,
        },
        {
          label: {
            en: 'No cases of forced labour',
            fr: 'Pas de cas de travail forcé',
          },
          description: {
            en: 'No evidence of forced labour occurring at the workplace.',
            fr: "Le travail forcé sur le lieu de travail et dans ses environs n'ont été identifié.",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Dangerous and lethal impact on human rights standards and working conditions',
            fr: "Impact dangereux et mortel en matière de droits de l'homme et des normes de conditions de travail",
          },
          description: {
            en: "Forced labour puts workers' dignity, security, and health at risk, and their life in peril.",
            fr: 'Le travail forcé par les supérieurs met en danger la dignité, la sécurité et la santé des travailleurs, ainsi que leur vie.',
          },
          value: 5,
        },
        {
          label: {
            en: 'Dangerous impact on human rights standards and working conditions',
            fr: "Impact dangereux en matière de droits de l'homme et des normes de conditions de travail",
          },
          description: {
            en: "Forced labour puts workers' dignity, security, and health at risk.",
            fr: 'Le travail forcé par les supérieurs met en danger la dignité, la sécurité et la santé des travailleurs.',
          },
          value: 4,
        },
        {
          label: {
            en: 'Sub-standard human rights standards and working conditions',
            fr: "Droits de l'homme et normes de conditions de travail inférieures à la norme",
          },
          description: {
            en: "Forced labour puts workers' dignity and health at risk.",
            fr: 'Le travail forcé par les supérieurs met en danger la dignité et la santé des travailleurs.',
          },
          value: 3,
        },
        {
          label: {
            en: 'Minor negative impact on human rights standards and working conditions',
            fr: "Impact négatif mineur en matière de droits de l'homme et des normes de conditions de travail",
          },
          description: {
            en: "Forced labour can put workers' dignity at risk.",
            fr: 'Le travail forcé par les supérieurs peut mettre en danger la dignité et/ou la santé des travailleurs.',
          },
          value: 2,
        },
        {
          label: {
            en: 'No negative impact on human rights standards and working conditions',
            fr: "Aucun impact négatif en matière de droits de l'homme et des normes de conditions de travail",
          },
          description: {
            en: "Cases of forced labour, if found to exist, do not put workers' dignity, health, security or life at risk.",
            fr: 'Les cas de travail forcé, si avérés, ne mettent pas en danger la dignité, la santé, la sécurité ou la vie des travailleurs.',
          },
          value: 1,
        },
      ],
    },
    childLabour: {
      threat: [
        {
          label: {
            en: 'Systematic practice of child labour',
            fr: 'Pratique systématique du travail des enfants',
          },
          description: {
            en: 'Children make up for 50% or more of total workforce.',
            fr: "Le travail des enfants sur le lieu de travail et dans son environnement touche (plus de) 50% de la main d'oeuvre.",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread practice of child labour',
            fr: 'Pratique généralisée du travail des enfants',
          },
          description: {
            en: 'Children make up for 25-50% of total workforce.',
            fr: "Le travail des enfants sur le lieu de travail et dans son environnement touche 25-50% de la main d'oeuvre.",
          },
          value: 4,
        },
        {
          label: {
            en: 'Large practice of child labour',
            fr: 'Pratique importante du travail des enfants',
          },
          description: {
            en: 'Children make up for 10-25% of total workforce.',
            fr: "Le travail des enfants sur le lieu de travail et dans son environnement touche 10-25% de la main d'oeuvre.",
          },
          value: 3,
        },
        {
          label: {
            en: 'Minor practice of child labour',
            fr: 'De rares cas de travail des enfants',
          },
          description: {
            en: 'Children make up for (less than) 10% of total workforce.',
            fr: "Le travail des enfants sur le lieu de travail et dans son environnement touche (moins de) 10% de la main d'oeuvre.",
          },
          value: 2,
        },
        {
          label: {
            en: 'No cases of child labour',
            fr: 'Pas de cas de travail des enfants',
          },
          description: {
            en: 'No evidence of child labour occurring at the workplace.',
            fr: "Le travail des enfants sur le lieu de travail et dans ses environs n'ont été identifié.",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Hazardous work',
            fr: 'Travaux dangereux',
          },
          description: {
            en: "Hazardous work that may directly endanger children's life, health, safety, and moral development.",
            fr: 'Travaux dangereux qui peuvent mettre directement en danger la vie, la santé, la sécurité et le développement moral des enfants.',
          },
          value: 5,
        },
        {
          label: {
            en: 'Heavy work',
            fr: 'Travaux lourds',
          },
          description: {
            en: 'Regular heavy work under coercion applied by parents or another third party and which may fully affect access to schooling.',
            fr: "Travail régulier et lourd sous la contrainte des parents ou d'un autre tiers et qui peut affecter pleinement l'accès à la scolarité.",
          },
          value: 4,
        },
        {
          label: {
            en: 'Light work',
            fr: 'Travaux légers',
          },
          description: {
            en: 'Regular light work under coercion applied by parents or another third party and which may partially affect access to schooling.',
            fr: "Travaux légers réguliers sous la contrainte des parents ou d'un autre tiers et qui peuvent affecter partiellement l'accès à la scolarité.",
          },
          value: 3,
        },
        {
          label: {
            en: 'Legitimate or domestic work',
            fr: 'Travail légitime ou domestique',
          },
          description: {
            en: "Occasional work under legal age or household chores which do not affect children's rights or access to schooling.",
            fr: "Travail occasionnel avant l'âge légal ou tâches ménagères qui n'affectent pas les droits des enfants ou leur accès à la scolarité.",
          },
          value: 2,
        },
        {
          label: {
            en: 'No work given to children',
            fr: 'Aucun travail donné aux enfants',
          },
          description: {
            en: "No negative impact on community children's rights or access to schooling.",
            fr: 'Aucun impact négatif sur les droits des enfants de la communauté ou sur leur accès à la scolarité.',
          },
          value: 1,
        },
      ],
    },
    sexualExploitation: {
      threat: [
        {
          label: {
            en: 'Systematic practice of sexual exploitation',
            fr: "Pratique systématique de l'exploitation sexuelle",
          },
          description: {
            en: '50% or more of workforce women are subject to sexual exploitation.',
            fr: "50% (ou plus) des femmes actives sont soumises à l'exploitation sexuelle.",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread practice of sexual exploitation',
            fr: "Pratique généralisée de l'exploitation sexuelle",
          },
          description: {
            en: '25-50% of workforce women are subject to sexual exploitation.',
            fr: "25-50% des femmes actives sont soumises à l'exploitation sexuelle.",
          },
          value: 4,
        },
        {
          label: {
            en: 'Large practice of sexual exploitation',
            fr: "Pratique importante de l'exploitation sexuelle",
          },
          description: {
            en: '10-25% or less of workforce women are subject to sexual exploitation.',
            fr: "10-25% des femmes actives sont soumises à l'exploitation sexuelle.",
          },
          value: 3,
        },
        {
          label: {
            en: 'Minor practice of sexual exploitation',
            fr: "De rares cas d'exploitation sexuelle",
          },
          description: {
            en: '10% or less of workforce women are subject to sexual exploitation.',
            fr: "10% (ou moins) des femmes actives sont victimes d'exploitation sexuelle.",
          },
          value: 2,
        },
        {
          label: {
            en: 'No cases of sexual exploitation',
            fr: "Pas de cas d'exploitation sexuelle",
          },
          description: {
            en: 'No evidence of sexual exploitation occurring at the workplace.',
            fr: "Aucune preuve d'exploitation sexuelle sur le lieu de travail.",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Fatal sexual assault',
            fr: 'Agressions sexuelles mortelles',
          },
          description: {
            en: "Women's life, health, safety, and moral development may be endangered by the violent nature of the sexual exploitation.",
            fr: "La vie, la santé, la sécurité et le développement moral des femmes peuvent être mis en danger par la nature violente de l'exploitation sexuelle.",
          },
          value: 5,
        },
        {
          label: {
            en: 'Violent sexual harassment and assault',
            fr: 'Harcèlement et agression sexuels violents',
          },
          description: {
            en: 'Women may suffer lasting physical / psychological harm from the violent nature of the sexual exploitation.',
            fr: "Les femmes peuvent subir des dommages physiques et psychologiques durables en raison de la nature violente de l'exploitation sexuelle.",
          },
          value: 4,
        },
        {
          label: {
            en: 'Violent sexual harassment ',
            fr: 'Harcèlement sexuel violent',
          },
          description: {
            en: 'Women may suffer physical / psychological harm from the violent nature of the sexual harassment.',
            fr: 'Les femmes peuvent subir un préjudice physique ou psychologique en raison de la nature violente du harcèlement sexuel.',
          },
          value: 3,
        },
        {
          label: {
            en: 'Light sexual harassment',
            fr: 'Harcèlement sexuel léger',
          },
          description: {
            en: 'Women may suffer minor physical / psychological harm from unwanted sexual advances or sexual harassment.',
            fr: "Les femmes peuvent subir un préjudice physique ou psychologique mineur en raison d'avances sexuelles non désirées ou de harcèlement sexuel.",
          },
          value: 2,
        },
        {
          label: {
            en: 'No harm or sexual harassment',
            fr: 'Pas de préjudice ou de harcèlement sexuel',
          },
          description: {
            en: "No negative impact on women's life, health, safety, and moral development at the workplace.",
            fr: 'Aucun impact négatif sur la vie, la santé, la sécurité et le développement moral des femmes sur le lieu de travail.',
          },
          value: 1,
        },
      ],
    },
    humanTrafficking: {
      threat: [
        {
          label: {
            en: 'Systematic practice of human trafficking',
            fr: "Pratique systématique de la traite d'êtres humains",
          },
          description: {
            en: 'Victims of human trafficking make up for 50% or more of total workforce.',
            fr: "Les victimes de la traite des êtres humains représentent 50% ou plus de la main-d'œuvre totale.",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread practice of human trafficking',
            fr: "Pratique généralisée de la traite d'êtres humains",
          },
          description: {
            en: 'Victims of human trafficking make up for 25-50% of total workforce.',
            fr: "Les victimes de la traite des êtres humains représentent 25-50% de la main-d'œuvre totale.",
          },
          value: 4,
        },
        {
          label: {
            en: 'Large practice of human trafficking',
            fr: "Pratique importante de la traite d'êtres humains",
          },
          description: {
            en: 'Victims of human trafficking make up for 10-25% of total workforce.',
            fr: "Les victimes de la traite des êtres humains représentent 10-25% de la main-d'œuvre totale.",
          },
          value: 3,
        },
        {
          label: {
            en: 'Minor practice of human trafficking',
            fr: 'De rares cas de traite des êtres humains',
          },
          description: {
            en: 'Victims of human trafficking make up for 10% or less of total workforce.',
            fr: "Les victimes de la traite des êtres humains représentent 10% ou moins de la main-d'œuvre totale.",
          },
          value: 2,
        },
        {
          label: {
            en: 'No cases of human trafficking',
            fr: 'Pas de cas de traite des êtres humains',
          },
          description: {
            en: 'No evidence of human trafficking occurring at the workplace.',
            fr: 'Aucune preuve de traite des êtres humains sur le lieu de travail.',
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Traffic may lead to hazardous and fatal forms of exploitation',
            fr: "La traite peut conduire à des formes d'exploitation dangereuses et mortelles",
          },
          description: {
            en: "Victims' life, health, safety, and moral development may be endangered by the hazardous nature of the trafficking or exploitation.",
            fr: "La vie, la santé, la sécurité et le développement moral des victimes peuvent être mis en danger par la nature dangereuse de la traite ou de l'exploitation.",
          },
          value: 5,
        },
        {
          label: {
            en: 'Traffic may lead to dangerous and violent forms of exploitation',
            fr: "La traite peut conduire à des formes d'exploitation dangereuses et violentes",
          },
          description: {
            en: 'Victims may suffer lasting physical / psychological harm from the violent nature of the trafficking or exploitation.',
            fr: "La traite peut conduire à des formes d'exploitation dangereuses et violentes",
          },
          value: 4,
        },
        {
          label: {
            en: 'Traffic may lead to harmful forms of exploitation',
            fr: "Le trafic peut conduire à des formes d'exploitation nuisibles",
          },
          description: {
            en: 'Victims may suffer physical / psychological harm from the coercive nature of the trafficking or exploitation.',
            fr: "Les victimes peuvent subir des dommages physiques ou psychologiques du fait de la nature coercitive de la traite ou de l'exploitation.",
          },
          value: 3,
        },
        {
          label: {
            en: 'Traffic may lead to non-harmful forms of exploitation',
            fr: "La traite peut conduire à des formes d'exploitation non préjudiciables",
          },
          description: {
            en: 'Victims are deceived about the working conditions when recruited but are not harmed.',
            fr: 'Les victimes sont trompées sur les conditions de travail lors du recrutement mais ne subissent aucun préjudice.',
          },
          value: 2,
        },
        {
          label: {
            en: 'No harm or working conditions deception',
            fr: 'Pas de préjudice ni de tromperie sur les conditions de travail',
          },
          description: {
            en: "No negative impact on workers' life, health, safety, and moral development at the workplace.",
            fr: 'Aucun impact négatif sur la vie, la santé, la sécurité et le développement moral des travailleurs sur le lieu de travail.',
          },
          value: 1,
        },
      ],
    },
  },
  conflictSecurity: {
    all: {
      vulnerability: [
        {
          label: {
            en: 'Stakeholders lack awareness of the issue',
            fr: 'Les parties prenantes ne sont pas conscientes du problème',
          },
          value: 5,
        },
        {
          label: {
            en: 'Stakeholders are aware of risk but are not able to monitor it',
            fr: 'Les parties prenantes sont conscientes du risque mais ne sont pas en mesure de le contrôler',
          },
          value: 4,
        },
        {
          label: {
            en: 'Stakeholders can monitor but not mitigate risk',
            fr: "Les parties prenantes peuvent surveiller le risque, mais pas l'atténuer",
          },
          value: 3,
        },
        {
          label: {
            en: 'Stakeholders can monitor and mitigate risk but with mixed results',
            fr: 'Les parties prenantes peuvent surveiller et atténuer le risque, mais avec des résultats mitigés',
          },
          value: 2,
        },
        {
          label: {
            en: 'Stakeholders can fully monitor and mitigate risk',
            fr: 'Les parties prenantes peuvent pleinement surveiller et atténuer le risque',
          },
          value: 1,
        },
      ],
      riskScore: [],
    },
    violenceAgainstCivilians: {
      threat: [
        {
          label: {
            en: 'Pervasive cases of violence against civilians',
            fr: 'Cas systématiques de violence contre des civils',
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread cases of violence against civilians',
            fr: 'Cas généralisés de violence contre des civils',
          },
          value: 4,
        },
        {
          label: {
            en: 'Significant cases of violence against civilians',
            fr: 'Cas significatifs de violence contre des civils',
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare cases of violence against civilians',
            fr: "Rares cas de violence à l'encontre des civils",
          },
          value: 2,
        },
        {
          label: {
            en: 'No case of violence against civilians',
            fr: 'Aucun cas de violence contre des civils',
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious, far-reaching and life-threatening effect on the security of civilians',
            fr: 'Effet pernicieux, de grande portée et mettant en danger la vie des civils',
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable majeur sur la sécurité des civils',
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on the security of civilians',
            fr: 'Aucun effet préjudiciable sur la sécurité des civils',
          },
          value: 1,
        },
      ],
    },
    kidnappingOfCivilians: {
      threat: [
        {
          label: {
            en: 'Systematic cases of abduction / kidnapping of civilians',
            fr: "Cas systématiques d'enlèvement / kidnapping de civils",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread cases of abduction / kidnapping of civilians',
            fr: "Cas généralisés d'enlèvement / kidnapping de civils",
          },
          value: 4,
        },
        {
          label: {
            en: 'Significant cases of abduction / kidnapping of civilians',
            fr: "Cas significatifs d'enlèvement / kidnapping de civils",
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare cases of abduction / kidnapping of civilians',
            fr: "Rares cas d'enlèvement / kidnapping de civils",
          },
          value: 2,
        },
        {
          label: {
            en: 'No case of abduction / kidnapping of civilians',
            fr: "Aucun cas d'enlèvement / kidnapping de civils",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious, far-reaching and life-threatening effect on the security of civilians',
            fr: 'Effet pernicieux, de grande portée et mettant en danger la vie des civils',
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable majeur sur la sécurité des civils',
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on the security of civilians',
            fr: 'Aucun effet préjudiciable sur la sécurité des civils',
          },
          value: 1,
        },
      ],
    },
    groupClash: {
      threat: [
        {
          label: {
            en: 'Pervasive group clashes between non-state armed groups and/or between non-state armed group and state armed forces',
            fr: "Affrontements omniprésents entre des groupes armés non étatiques et/ou entre un groupe armé non étatique et les forces armées de l'État",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread group clashes between non-state armed groups and/or between non-state armed group and state armed forces',
            fr: "Affrontements généralisés entre des groupes armés non étatiques et/ou entre un groupe armé non étatique et les forces armées de l'État",
          },
          value: 4,
        },
        {
          label: {
            en: 'Significant group clashes between non-state armed groups and/or between non-state armed group and state armed forces',
            fr: "Affrontements importants entre des groupes armés non étatiques et/ou entre un groupe armé non étatique et les forces armées de l'État",
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare group clashes between non-state armed groups and/or between non-state armed group and state armed forces',
            fr: "Affrontements rares entre des groupes armés non étatiques et/ou entre un groupe armé non étatique et les forces armées de l'État",
          },
          value: 2,
        },
        {
          label: {
            en: 'No group clash between non-state armed groups and/or between non-state armed group and state armed forces',
            fr: "Aucun affrontement entre des groupes armés non étatiques et/ou entre un groupe armé non étatique et les forces armées de l'État",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious, far-reaching and life-threatening effect on the security of civilians',
            fr: 'Effet pernicieux, de grande portée et mettant en danger la vie des civils',
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable majeur sur la sécurité des civils',
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on the security of civilians',
            fr: 'Aucun effet préjudiciable sur la sécurité des civils',
          },
          value: 1,
        },
      ],
    },
    armedGroupPresence: {
      threat: [
        {
          label: {
            en: 'Pervasive presence or incursions of armed groups',
            fr: 'Présence ou incursions omniprésentes de groupes armés',
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread presence or incursions of armed groups',
            fr: 'Présence ou incursions généralisées de groupes armés',
          },
          value: 4,
        },
        {
          label: {
            en: 'Large presence or significant incursions of armed groups',
            fr: 'Présence ou incursions significatives de groupes armés',
          },
          value: 3,
        },
        {
          label: {
            en: 'Minor presence or incursions of armed groups',
            fr: 'Rares présence ou incursions de groupes armés',
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on the security of civilians',
            fr: 'Aucune présence ou incursion de groupes armés',
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious, far-reaching and life-threatening effect on the security of civilians',
            fr: 'Effet pernicieux, de grande portée et mettant en danger la vie des civils',
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable majeur sur la sécurité des civils',
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on the security of civilians',
            fr: 'Aucun effet préjudiciable sur la sécurité des civils',
          },
          value: 1,
        },
      ],
    },
    identityBasedConflictOrTension: {
      threat: [
        {
          label: {
            en: 'Pervasive identity-based conflict(s) or tension(s)',
            fr: 'Conflit(s) ou tension(s) identitaire(s) systématique(s)',
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread identity-based conflict(s) or tension(s)',
            fr: 'Conflit(s) ou tension(s) identitaire(s) généralisé(s)',
          },
          value: 4,
        },
        {
          label: {
            en: 'Significant identity-based conflict(s) or tension(s)',
            fr: 'Conflit(s) ou tension(s) identitaire(s) important(s)',
          },
          value: 3,
        },
        {
          label: {
            en: 'Minor identity-based conflict(s) or tension(s)',
            fr: 'Conflit(s) ou tension(s) identitaire(s) mineur(s)',
          },
          value: 2,
        },
        {
          label: {
            en: 'No identity-based conflict or tension',
            fr: 'Aucun conflit ou tension identitaire',
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious, far-reaching and life-threatening effect on the security of civilians',
            fr: 'Effet pernicieux, de grande portée et mettant en danger la vie des civils ',
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable majeur sur la sécurité des civils',
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on the security of civilians',
            fr: 'Aucun effet préjudiciable sur la sécurité des civils',
          },
          value: 1,
        },
      ],
    },
    warCrime: {
      threat: [
        {
          label: {
            en: 'Pervasive cases of war crime',
            fr: 'Cas systématiques de crimes de guerre ',
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread cases of war crime',
            fr: 'Cas généralisés de crimes de guerre',
          },
          value: 4,
        },
        {
          label: {
            en: 'Significant cases of war crime',
            fr: 'Cas significatifs de crimes de guerre',
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare cases of war crime',
            fr: 'De rares cas de crimes de guerre',
          },
          value: 2,
        },
        {
          label: {
            en: 'No case of war crime',
            fr: 'Aucun cas de crime de guerre',
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious, far-reaching and deadly effect on the security of civilians',
            fr: 'Effet pernicieux, de grande portée et mettant en danger la vie des civils ',
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable majeur sur la sécurité des civils',
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on the security of civilians',
            fr: 'Aucun effet préjudiciable sur la sécurité des civils',
          },
          value: 1,
        },
      ],
    },
    crimeAgainstHumanityOrGenocide: {
      threat: [
        {
          label: {
            en: 'Pervasive cases of crime against humanity',
            fr: "Cas systématiques de crimes contre l'humanité",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread cases of crime against humanity',
            fr: "Cas généralisés de crimes contre l'humanité",
          },
          value: 4,
        },
        {
          label: {
            en: 'Significant cases of crime against humanity',
            fr: "Cas significatifs de contre l'humanité",
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare cases of crime against humanity',
            fr: "De rares cas de crimes contre l'humanité",
          },
          value: 2,
        },
        {
          label: {
            en: 'No case of crime against humanity',
            fr: "Aucun cas de crime contre l'humanité",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious, far-reaching and deadly effect on the security of civilians',
            fr: 'Effet pernicieux, de grande portée et mettant en danger la vie des civils ',
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable majeur sur la sécurité des civils',
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on the security of civilians',
            fr: 'Aucun effet préjudiciable sur la sécurité des civils',
          },
          value: 1,
        },
      ],
    },
    terrorism: {
      threat: [
        {
          label: {
            en: 'Pervasive cases of act of terrorism',
            fr: 'Cas systématiques de terrorisme',
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread cases of act of terrorism',
            fr: 'Cas généralisés de terrorisme',
          },
          value: 4,
        },
        {
          label: {
            en: 'Significant cases of act of terrorism',
            fr: 'Cas significatifs de terrorisme',
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare cases of act of terrorism',
            fr: 'De rares cas de terrorisme',
          },
          value: 2,
        },
        {
          label: {
            en: 'No case of act of terrorism',
            fr: 'Aucun cas de terrorisme',
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious, far-reaching and deadly effect on the security of civilians',
            fr: 'Effet pernicieux, de grande portée et mettant en danger la vie des civils ',
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable majeur sur la sécurité des civils',
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on the security of civilians',
            fr: 'Aucun effet préjudiciable sur la sécurité des civils',
          },
          value: 1,
        },
      ],
    },
    destructionOfProperty: {
      threat: [
        {
          label: {
            en: 'Systematic practice of destruction of property',
            fr: 'Cas systématiques de destruction de biens',
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread practice of destruction of property',
            fr: 'Cas généralisés de destruction de biens',
          },
          value: 4,
        },
        {
          label: {
            en: 'Large practice of destruction of property',
            fr: 'Cas significatifs de destruction de biens',
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare cases of destruction of property',
            fr: 'De rares cas de destruction de biens',
          },
          value: 2,
        },
        {
          label: {
            en: 'No case of destruction of property',
            fr: 'Aucun cas de destruction de biens',
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious, far-reaching and deadly effect on the security of civilians',
            fr: 'Effet pernicieux, de grande portée et mettant en danger la vie des civils ',
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable majeur sur la sécurité des civils',
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on the security of civilians',
            fr: 'Aucun effet préjudiciable sur la sécurité des civils',
          },
          value: 1,
        },
      ],
    },
    pillageLootingOfPropertyOrGoods: {
      threat: [
        {
          label: {
            en: 'Systematic practice of pillage / looting of property and /or goods',
            fr: 'Cas systématiques de pillage de biensCas systématiques de pillage de biens',
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread practice of pillage / looting of property and /or goods',
            fr: 'Cas généralisés de pillage de biens',
          },
          value: 4,
        },
        {
          label: {
            en: 'Large practice of pillage / looting of property and /or goods',
            fr: 'Cas significatifs de pillage de biens',
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare cases of pillage / looting of property and /or goods',
            fr: 'De rares cas de pillage de biens',
          },
          value: 2,
        },
        {
          label: {
            en: 'No case of pillage / looting of property and /or goods',
            fr: 'Aucun cas de pillage de biens',
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious, far-reaching and deadly effect on the security of civilians',
            fr: 'Effet pernicieux, de grande portée et mettant en danger la vie des civils ',
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable majeur sur la sécurité des civils',
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on the security of civilians',
            fr: 'Aucun effet préjudiciable sur la sécurité des civils',
          },
          value: 1,
        },
      ],
    },
    theft: {
      threat: [
        {
          label: {
            en: 'Pervasive cases of theft ',
            fr: 'Cas systématiques de vol',
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread cases of theft ',
            fr: 'Cas généralisés de vol ',
          },
          value: 4,
        },
        {
          label: {
            en: 'Significant cases of theft ',
            fr: 'Cas significatifs de vol ',
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare cases of theft ',
            fr: 'De rares cas de vol',
          },
          value: 2,
        },
        {
          label: {
            en: 'No case of theft ',
            fr: 'Aucun cas de vol',
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious, far-reaching and deadly effect on the security of civilians',
            fr: 'Effet pernicieux, de grande portée et mettant en danger la vie des civils ',
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable majeur sur la sécurité des civils',
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on the security of civilians',
            fr: 'Aucun effet préjudiciable sur la sécurité des civils',
          },
          value: 1,
        },
      ],
    },
    riotDemonstrations: {
      threat: [
        {
          label: {
            en: 'Pervasive cases of riot / demonstrations ',
            fr: "Cas systématiques d'émeute / de manifestation",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread cases of riot / demonstrations ',
            fr: "Cas généralisés d'émeute / de manifestation",
          },
          value: 4,
        },
        {
          label: {
            en: 'Significant cases of riot / demonstrations ',
            fr: "Cas significatifs d'émeute / de manifestation",
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare cases of riot / demonstrations ',
            fr: "De rares cas d'émeute / de manifestation",
          },
          value: 2,
        },
        {
          label: {
            en: 'No case of riot / demonstrations ',
            fr: "Aucun cas d'émeute / de manifestation",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious, far-reaching and deadly effect on the security of civilians',
            fr: 'Effet pernicieux, de grande portée et mettant en danger la vie des civils ',
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable majeur sur la sécurité des civils',
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on the security of civilians',
            fr: 'Aucun effet préjudiciable sur la sécurité des civils',
          },
          value: 1,
        },
      ],
    },
    remoteViolence: {
      threat: [
        {
          label: {
            en: 'Pervasive cases of remote violence ',
            fr: 'Cas systématiques de violence à distance',
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread cases of remote violence ',
            fr: 'Cas généralisés de violence à distance',
          },
          value: 4,
        },
        {
          label: {
            en: 'Significant cases of remote violence ',
            fr: 'Cas significatifs de violence à distance',
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare cases of remote violence ',
            fr: 'De rares cas de violence à distance',
          },
          value: 2,
        },
        {
          label: {
            en: 'No case of remote violence ',
            fr: 'Aucun cas de violence à distance',
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious, far-reaching and deadly effect on the security of civilians',
            fr: 'Effet pernicieux, de grande portée et mettant en danger la vie des civils ',
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable majeur sur la sécurité des civils',
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on the security of civilians',
            fr: 'Aucun effet préjudiciable sur la sécurité des civils',
          },
          value: 1,
        },
      ],
    },
    politicalRepression: {
      threat: [
        {
          label: {
            en: 'Pervasive cases of political repression',
            fr: 'Cas systématiques de répression politique',
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread cases of political repression',
            fr: 'Cas généralisés de répression politique',
          },
          value: 4,
        },
        {
          label: {
            en: 'Significant cases of political repression',
            fr: 'Cas significatifs de répression politique',
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare cases of political repression',
            fr: 'De rares cas de répression politique',
          },
          value: 2,
        },
        {
          label: {
            en: 'No case of political repression',
            fr: 'Aucun cas de répression politique',
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious, far-reaching and deadly effect on the security of civilians',
            fr: 'Effet pernicieux, de grande portée et mettant en danger la vie des civils ',
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable majeur sur la sécurité des civils',
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on the security of civilians',
            fr: 'Effet préjudiciable modéré sur la sécurité des civils',
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on the security of civilians',
            fr: 'Aucun effet préjudiciable sur la sécurité des civils',
          },
          value: 1,
        },
      ],
    },
    sexualGenderBasedViolence: {
      threat: [
        {
          label: {
            en: 'Pervasive cases of sexual and gender-based violence',
            fr: 'Cas systématiques de violence sexuelle et basée sur le genre',
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread cases of sexual and gender-based violence',
            fr: 'Cas généralisés de violence sexuelle et basée sur le genre',
          },
          value: 4,
        },
        {
          label: {
            en: 'Significant cases of sexual and gender-based violence',
            fr: 'Cas significatifs de violence sexuelle et basée sur le genre',
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare cases of sexual and gender-based violence',
            fr: 'De rares cas de violence sexuelle et basée sur le genre',
          },
          value: 2,
        },
        {
          label: {
            en: 'No case of sexual and gender-based violence',
            fr: 'Aucun cas de violence sexuelle et basée sur le genre',
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Dangerous and life-threatening impact on the lives, security, physical and moral integrity of individuals',
            fr: "Impact dangereux et potentiellement mortel sur la vie, la sécurité, l'intégrité physique et morale des individus",
          },
          value: 5,
        },
        {
          label: {
            en: 'Dangerous and highly detrimental impact on the lives, security, physical and moral integrity of individuals',
            fr: "Impact dangereux et très préjudiciable sur la vie, la sécurité, l'intégrité physique et morale des individus",
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental impact on the lives, security, physical and moral integrity of individuals',
            fr: "Impact délétère modéré sur la vie, la sécurité, l'intégrité physique et morale des individus",
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious impact on the lives, security, physical and moral integrity of individuals',
            fr: "Impact délétère limité sur la vie, la sécurité, l'intégrité physique et morale des individus",
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental impact on the lives, security, physical and moral integrity of individuals',
            fr: "Aucun impact négatif sur la vie, la sécurité, l'intégrité physique et morale des individus",
          },
          value: 1,
        },
      ],
    },
  },
  environment: {
    all: {
      vulnerability: [
        {
          label: {
            en: 'Stakeholders lack awareness of the issue',
            fr: 'Les parties prenantes ne sont pas conscientes du problème',
          },
          value: 5,
        },
        {
          label: {
            en: 'Stakeholders are aware of risk but are not able to monitor it',
            fr: 'Les parties prenantes sont conscientes du risque mais ne sont pas en mesure de le contrôler',
          },
          value: 4,
        },
        {
          label: {
            en: 'Stakeholders can measure but not mitigate risk',
            fr: "Les parties prenantes peuvent surveiller le risque, mais pas l'atténuer",
          },
          value: 3,
        },
        {
          label: {
            en: 'Stakeholders can measure, monitor and mitigate risk but with mixed results',
            fr: 'Les parties prenantes peuvent surveiller et atténuer le risque, mais avec des résultats mitigés',
          },
          value: 2,
        },
        {
          label: {
            en: 'Stakeholders can fully measure, monitor and mitigate risk',
            fr: 'Les parties prenantes peuvent pleinement surveiller et atténuer le risque',
          },
          value: 1,
        },
      ],
      riskScore: [],
    },
    conversationAligment: {
      threat: [
        {
          label: {
            en: 'Pervasive misalignment between conservation goals and community priorities',
            fr: 'Discordance systématique entre les objectifs de conservation et les priorités des communautés',
          },
          description: {
            en: "Conflicts between mining operators and local authorities exist, i.e. mineral extraction is considered an impediment to the local area's conservation goals",
            fr: "Il existe des conflits entre les exploitants miniers et les autorités locales, c'est-à-dire que l'extraction minière est considérée comme une entrave aux objectifs de conservation de la zone locale.",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread misalignment between conservation goals and community priorities',
            fr: 'Discordance généralisé entre les objectifs de conservation et les priorités de la communauté',
          },
          description: {
            en: 'Mining extraction is mostly misaligned with the conservation goals of the area where it is located',
            fr: "L'extraction minière est le plus souvent en décalage avec les objectifs de conservation de la zone où elle est située.",
          },
          value: 4,
        },
        {
          label: {
            en: 'Large misalignment between conservation goals and community priorities',
            fr: 'Discordance importante entre les objectifs de conservation et les priorités de la communauté',
          },
          description: {
            en: 'Mining extraction is partially aligned with the conservation goals of the area where it is located',
            fr: "L'extraction minière est partiellement alignée sur les objectifs de conservation de la région où elle est située.",
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare misalignment between conservation goals and community priorities',
            fr: 'Rare décalage entre les objectifs de conservation et les priorités de la communauté',
          },
          description: {
            en: 'Mining extraction is mostly aligned with the conservation goals of the area where it is located',
            fr: "L'extraction minière est en grande partie alignée sur les objectifs de conservation de la région où elle est située.",
          },
          value: 2,
        },
        {
          label: {
            en: 'No misalignment between conservation goals and community priorities',
            fr: 'Aucun décalage entre les objectifs de conservation et les priorités de la communauté',
          },
          description: {
            en: 'Mining extraction is aligned with the conservation goals of the area where it is located',
            fr: "L'extraction minière est alignée sur les objectifs de conservation de la région où elle est située.",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: "Pernicious effect on the community's health and livelihood and / or the sustainability of the area's biodiversity, landscape and natural resources values",
            fr: 'Effet néfaste sur la santé et les moyens de subsistance de la communauté et/ou sur la durabilité de la biodiversité, du paysage et des ressources naturelles de la zone',
          },
          value: 5,
        },
        {
          label: {
            en: "Major detrimental effect on the community's health and livelihood and / or the sustainability of the area's biodiversity, landscape and natural resources values",
            fr: 'Effet préjudiciable majeur sur la santé et les moyens de subsistance de la communauté et/ou sur la durabilité de la biodiversité, du paysage et des ressources naturelles de la zone',
          },
          value: 4,
        },
        {
          label: {
            en: "Moderate detrimental effect on the community's health and livelihood and / or the sustainability of the area's biodiversity, landscape and natural resources values",
            fr: 'Effet préjudiciable modéré sur la santé et les moyens de subsistance de la communauté et/ou sur la durabilité de la biodiversité, du paysage et des ressources naturelles de la zone',
          },
          value: 3,
        },
        {
          label: {
            en: "Limited deleterious effect on the community's health and livelihood and / or the sustainability of the area's biodiversity, landscape and natural resources values",
            fr: 'Effet nuisible limité sur la santé et les moyens de subsistance de la communauté et/ou sur la durabilité de la biodiversité, du paysage et des ressources naturelles de la zone',
          },
          value: 2,
        },
        {
          label: {
            en: "No detrimental effect on the community's health and livelihood and / or the sustainability of the area's biodiversity, landscape and natural resources values",
            fr: 'Aucun effet négatif sur la santé et les moyens de subsistance de la communauté et/ou sur la durabilité de la biodiversité, du paysage et des ressources naturelles de la zone',
          },
          value: 1,
        },
      ],
    },
    sustainableLand: {
      threat: [
        {
          label: {
            en: 'Pervasive disregard for post-mining reclamation',
            fr: "Mépris systématique pour la remise en état des sites après l'exploitation minière",
          },
          description: {
            en: 'Damages to mined land are never restored through reclamation efforts which would help maintain social conditions and environmental sustainability',
            fr: 'Les dommages causés aux terres exploitées ne sont jamais réparés par les efforts de remise en état qui permettraient de maintenir les conditions sociales et la durabilité environnementale.',
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread disregard for post-mining reclamation',
            fr: "Mépris généralisé pour la remise en état des sites après l'exploitation minière",
          },
          description: {
            en: 'Damages to mined land are moslty not restored through reclamation efforts which would help maintain social conditions and environmental sustainability',
            fr: 'Les dommages subis par les terrains minés ne sont généralement pas compensés par des efforts de remise en état qui contribueraient à maintenir les conditions sociales et la durabilité environnementale.',
          },
          value: 4,
        },
        {
          label: {
            en: 'Large disregard for post-mining reclamation',
            fr: "Grand mépris pour la remise en état des sites après l'exploitation minière",
          },
          description: {
            en: 'Damages to mined land are generally not restored through reclamation efforts which would help maintain social conditions and environmental sustainability',
            fr: 'Les dommages causés aux terrains minés ne sont généralement pas compensés par des efforts de remise en état qui contribueraient à maintenir les conditions sociales et la durabilité environnementale.',
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare disregard for post-mining reclamation',
            fr: "Rare mépris pour la remise en état des sites après l'exploitation minière",
          },
          description: {
            en: 'Damages to mine land are mostly restored through reclamation efforts which maintain social conditions and environmental sustainability',
            fr: 'Les dommages causés aux terres minées sont généralement restaurés par des efforts de remise en état qui permettent de maintenir les conditions sociales et la durabilité environnementale.',
          },
          value: 2,
        },
        {
          label: {
            en: 'No disregard for post-mining reclamation',
            fr: 'Aucun mépris pour la remise en état des sites après exploitation',
          },
          description: {
            en: 'Damages to mined land are completely restored through reclamation efforts which maintain social conditions and environmental sustainability',
            fr: 'Les dommages subis par les terres minées sont complètement restaurés grâce à des efforts de remise en état qui permettent de maintenir les conditions sociales et la durabilité environnementale.',
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: "Pernicious effect on the community land's environmental sustainability and / or economic viability",
            fr: 'Effet néfaste sur la durabilité environnementale et/ou la viabilité économique des terres communautaires',
          },
          value: 5,
        },
        {
          label: {
            en: "Major detrimental effect on the community land's environmental sustainability and / or economic viability",
            fr: 'Effet préjudiciable majeur sur la durabilité environnementale et/ou la viabilité économique des terres communautaires',
          },
          value: 4,
        },
        {
          label: {
            en: "Moderate detrimental effect on the community land's environmental sustainability and / or economic viability",
            fr: 'Effet préjudiciable modéré sur la durabilité environnementale et/ou la viabilité économique des terres communautaires',
          },
          value: 3,
        },
        {
          label: {
            en: "Limited deleterious effect on the community land's environmental sustainability and / or economic viability",
            fr: 'Effet nuisible limité sur la durabilité environnementale et/ou la viabilité économique des terres de la communauté',
          },
          value: 2,
        },
        {
          label: {
            en: "No detrimental effect on the community land's environmental sustainability and / or economic viability",
            fr: 'Aucun effet négatif sur la durabilité environnementale et/ou la viabilité économique des terres communautaires',
          },
          value: 1,
        },
      ],
    },
    ecosystemProtection: {
      threat: [
        {
          label: {
            en: 'Pervasive pressure on and disregard for local ecosystems',
            fr: "Pression et mépris omniprésents à l'égard des écosystèmes locaux",
          },
          description: {
            en: 'Mining extraction takes place with complete disregard for the needs of essentiel hotspots of biodiversity and ecological functions, thereby unequivocally threatening their regeneration process ',
            fr: "L'extraction minière se fait au mépris total des besoins des points névralgiques de la biodiversité et des fonctions écologiques, menaçant ainsi sans équivoque leur processus de régénération.",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread pressure on and disregard for local ecosystems',
            fr: "Pression et mépris généralisés à l'égard des écosystèmes locaux",
          },
          description: {
            en: 'Mining extraction mostly takes place in disregard of the needs of essentiel hotspots of biodiversity and ecological functions, thereby threatening their regeneration process ',
            fr: "L'extraction minière se fait le plus souvent au mépris des besoins des sources essentielles de la biodiversité et des fonctions écologiques, menaçant ainsi leur processus de régénération.",
          },
          value: 4,
        },
        {
          label: {
            en: 'Large pressure on and disregard for local ecosystems',
            fr: "Pression et mépris importants à l'égard des écosystèmes locaux",
          },
          description: {
            en: 'Mining extraction generally takes place in disregard of the needs of essentiel hotspots of biodiversity and ecological functions, thereby posing a moderate threat to their regeneration process ',
            fr: "L'extraction minière se fait généralement au mépris des besoins des sources essentielles de la biodiversité et des fonctions écologiques, menaçant ainsi modérément leur processus de régénération.",
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare pressure on and disregard for local ecosystems',
            fr: "Rares pression et mépris à l'égard des écosystèmes locaux",
          },
          description: {
            en: 'Mining extraction rarely takes place in disregard of the needs of essentiel hotspots of biodiversity and ecological functions, thereby posing a minor threat to their regeneration process',
            fr: "L'extraction minière se fait rarement au mépris des besoins des sources essentielles de la biodiversité et des fonctions écologiques, ce qui constitue une menace mineure pour leur processus de régénération.",
          },
          value: 2,
        },
        {
          label: {
            en: 'No pressure on or disregard for local ecosystems',
            fr: "Aucune pression ou forme de mépris à l'égard des écosystèmes locaux",
          },
          description: {
            en: 'Mining extraction takes into account the needs of essentiel hotspots of biodiversity and ecological functions, thereby posing no threat to their regeneration process',
            fr: "L'extraction minière prend en compte les besoins des sources essentielles de la biodiversité et des fonctions écologiques, ce qui ne constitue pas une menace pour leur processus de régénération.",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: "Pernicious effect on local community health, livelihood, cultural heritage and / or its land's environmental sustainability",
            fr: 'Effet néfaste sur la santé, les moyens de subsistance, le patrimoine culturel et/ou la durabilité environnementale de la communauté locale',
          },
          value: 5,
        },
        {
          label: {
            en: "Major detrimental effect on local community health, livelihood, cultural heritage and / or its land's environmental sustainability",
            fr: 'Effet préjudiciable majeur sur la santé, les moyens de subsistance, le patrimoine culturel et/ou la durabilité environnementale de la communauté locale',
          },
          value: 4,
        },
        {
          label: {
            en: "Moderate detrimental effect on local community health, livelihood, cultural heritage and / or its land's environmental sustainability",
            fr: 'Effet préjudiciable modéré sur la santé, les moyens de subsistance, le patrimoine culturel et/ou la durabilité environnementale de la communauté locale',
          },
          value: 3,
        },
        {
          label: {
            en: "Limited deleterious effect on local community health, livelihood, cultural heritage and / or its land's environmental sustainability",
            fr: 'Effet nuisible limité sur la santé, les moyens de subsistance, le patrimoine culturel et/ou la durabilité environnementale de la communauté locale',
          },
          value: 2,
        },
        {
          label: {
            en: "No detrimental effect on local community health, livelihood, cultural heritage and / or its land's environmental sustainability",
            fr: 'Aucun effet néfaste sur la santé, les moyens de subsistance, le patrimoine culturel et/ou la viabilité environnementale des terres de la communauté locale',
          },
          value: 1,
        },
      ],
    },
    forestHealth: {
      threat: [
        {
          label: {
            en: 'Pervasive pressure on and disregard for forest health monitoring and regeneration best practices',
            fr: "Pression et mépris omniprésent à l'égard des meilleures pratiques de surveillance et de régénération de la santé des forêts",
          },
          description: {
            en: "Conflicts between mining operators and local authorities exist, i.e. mineral extraction is considered an impediment to local forests' regeneration process",
            fr: "Il existe des conflits entre les opérateurs miniers et les autorités locales, l'extraction minière étant considérée comme une entrave au processus de régénération des forêts locales.",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread pressure on and disregard for forest health monitoring and regeneration best practices',
            fr: "Pression et mépris généralisés à l'égard des meilleures pratiques de surveillance et de régénération de la santé des forêts",
          },
          description: {
            en: 'Mining extraction is mostly misaligned with the forest conservation goals of the area where it is located',
            fr: "L'extraction minière n'est généralement pas alignée sur les objectifs de conservation des forêts de la région où elle est située.",
          },
          value: 4,
        },
        {
          label: {
            en: 'Large pressure on and disregard for forest health monitoring and regeneration best practices',
            fr: "Pression et mépris importants à l'égard des meilleures pratiques de surveillance et de régénération de la santé des forêts",
          },
          description: {
            en: 'Mining extraction is partially aligned with the forest conservation goals of the area where it is located',
            fr: "L'extraction minière est partiellement alignée sur les objectifs de conservation des forêts de la région où elle est située.",
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare pressure on and disregard for forest health monitoring and regeneration best practices',
            fr: "Rare pression et mépris à l'égard des meilleures pratiques de surveillance et de régénération de la santé des forêts",
          },
          description: {
            en: 'Mining extraction is mostly aligned with the forest conservation goals of the area where it is located',
            fr: "L'extraction minière est en grande partie alignée sur les objectifs de conservation des forêts de la région où elle est située.",
          },
          value: 2,
        },
        {
          label: {
            en: 'No pressure on or disregard for forest health monitoring and regeneration best practices',
            fr: "Aucune pression à l'égard des meilleures pratiques de surveillance et de régénération de la santé des forêts",
          },
          description: {
            en: 'Mining extraction is aligned with the forest conservation goals of the area where it is located',
            fr: "L'extraction minière est alignée sur les objectifs de conservation des forêts de la région où elle est située.",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: "Pernicious effect on local community health and livelihood and / or its forest land's environmental sustainability",
            fr: 'Effet néfaste sur la santé et les moyens de subsistance de la communauté locale et/ou sur la durabilité environnementale de ses terres forestières',
          },
          value: 5,
        },
        {
          label: {
            en: "Major detrimental effect on local community health and livelihood and / or its forest land's environmental sustainability",
            fr: 'Effet préjudiciable majeur sur la santé et les moyens de subsistance de la communauté locale et/ou sur la durabilité environnementale de ses terres forestières',
          },
          value: 4,
        },
        {
          label: {
            en: "Moderate detrimental effect on local community health and livelihood and / or its forest land's environmental sustainability",
            fr: 'Effet préjudiciable modéré sur la santé et les moyens de subsistance de la communauté locale et/ou sur la viabilité environnementale de ses terres forestières',
          },
          value: 3,
        },
        {
          label: {
            en: "Limited deleterious effect on local community health and livelihood and / or its forest land's environmental sustainability",
            fr: 'Effet délétère limité sur la santé et les moyens de subsistance de la communauté locale et/ou sur la viabilité environnementale de ses terres forestières',
          },
          value: 2,
        },
        {
          label: {
            en: "No detrimental effect on local community health and livelihood and / or its forest land's environmental sustainability",
            fr: 'Aucun effet négatif sur la santé et les moyens de subsistance de la communauté locale et/ou sur la viabilité environnementale de ses terres',
          },
          value: 1,
        },
      ],
    },
    wastewaterContamination: {
      threat: [
        {
          label: {
            en: 'Pervasive wastewater contamination and / or water quality reduction',
            fr: "Contamination systématique des eaux usées et / ou réduction de la qualité de l'eau",
          },
          description: {
            en: 'All mineral extraction and processing activities (e.g. mercury amalgamation) unequivocally lead to wastewater contamination and / or a reduction in freshwater quality',
            fr: "Toutes les activités d'extraction et de traitement des minéraux (par exemple, l'amalgamation du mercure) entraînent sans équivoque une contamination des eaux usées et/ou une réduction de la qualité de l'eau douce.",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread wastewater contamination and / or water quality reduction',
            fr: "Contamination généralisée des eaux usées et / ou réduction de la qualité de l'eau",
          },
          description: {
            en: 'Most mineral extraction and processing activities (e.g. mercury amalgamation) lead to wastewater contamination and / or a reduction in freshwater quality',
            fr: "La plupart des activités d'extraction et de traitement des minéraux (par exemple, l'amalgamation du mercure) entraînent une contamination des eaux usées et/ou une réduction de la qualité des eaux douces.",
          },
          value: 4,
        },
        {
          label: {
            en: 'Significant wastewater contamination and / or water quality reduction',
            fr: "Contamination importante des eaux usées et / ou réduction de la qualité de l'eau",
          },
          description: {
            en: 'Some mineral extraction and processing activities (e.g. mercury amalgamation) lead to wastewater contamination and / or a reduction in freshwater quality',
            fr: "Certaines activités d'extraction et de traitement des minéraux (par exemple, l'amalgamation du mercure) entraînent une contamination des eaux usées et/ou une réduction de la qualité des eaux douces.",
          },
          value: 3,
        },
        {
          label: {
            en: 'Minor wastewater contamination and / or water quality reduction',
            fr: "Rare contamination des eaux usées et / ou réduction de la qualité de l'eau",
          },
          description: {
            en: 'Almost none of the mineral extraction and processing activities (e.g. mercury amalgamation) lead to wastewater contamination and / or a reduction in freshwater quality',
            fr: "Presque aucune des activités d'extraction et de traitement des minéraux (par exemple, l'amalgamation du mercure) ne conduit à une contamination des eaux usées et/ou à une réduction de la qualité des eaux douces.",
          },
          value: 2,
        },
        {
          label: {
            en: 'No wastewater contamination and / or water quality reduction',
            fr: "Aucune contamination des eaux usées et / ou réduction de la qualité de l'eau",
          },
          description: {
            en: 'None of the mineral extraction and processing activities lead to wastewater contamination and / or a reduction in freshwater quality',
            fr: "Aucune des activités d'extraction et de traitement des minéraux n'entraîne de contamination des eaux usées et/ou de réduction de la qualité des eaux douces.",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: "Pernicious effect on local community health and livelihood and / or its land's environmental sustainability",
            fr: 'Effet néfaste sur la durabilité environnementale et/ou la viabilité économique des terres communautaires',
          },
          value: 5,
        },
        {
          label: {
            en: "Major detrimental effect on local community health and livelihood and / or its land's environmental sustainability",
            fr: 'Effet préjudiciable majeur sur la durabilité environnementale et/ou la viabilité économique des terres communautaires',
          },
          value: 4,
        },
        {
          label: {
            en: "Moderate detrimental effect on local community health and livelihood and / or its land's environmental sustainability",
            fr: 'Effet préjudiciable modéré sur la durabilité environnementale et/ou la viabilité économique des terres communautaires',
          },
          value: 3,
        },
        {
          label: {
            en: "Limited deleterious effect on local community health and livelihood and / or its land's environmental sustainability",
            fr: 'Effet nuisible limité sur la durabilité environnementale et/ou la viabilité économique des terres de la communauté',
          },
          value: 2,
        },
        {
          label: {
            en: "No detrimental effect on local community health and livelihood and / or its land's environmental sustainability",
            fr: 'Aucun effet négatif sur la durabilité environnementale et/ou la viabilité économique des terres communautaires',
          },
          value: 1,
        },
      ],
    },
    soilPollution: {
      threat: [
        {
          label: {
            en: 'Pervasive soil pollution and contamination',
            fr: 'Pollution et contamination systématique des sols',
          },
          description: {
            en: 'All mineral extraction and processing activities (e.g. mercury amalgamation) unequivocally lead to soil pollution and contamination',
            fr: "Toutes les activités d'extraction et de traitement des minéraux (par exemple, l'amalgamation du mercure) entraînent sans équivoque une pollution et contamination des sols.",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread soil pollution and contamination',
            fr: 'Pollution et contamination généralisée des sols',
          },
          description: {
            en: 'Most mineral extraction and processing activities (e.g. mercury amalgamation) lead to soil pollution and contamination',
            fr: "La plupart des activités d'extraction et de traitement des minéraux (par exemple, l'amalgamation du mercure) entraînent une pollution et contamination des sols.",
          },
          value: 4,
        },
        {
          label: {
            en: 'Significant soil pollution and contamination',
            fr: 'Pollution et contamination importante des sols',
          },
          description: {
            en: 'Some mineral extraction and processing activities (e.g. mercury amalgamation) lead to soil pollution and contamination',
            fr: "Certaines activités d'extraction et de traitement des minéraux (par exemple, l'amalgamation du mercure) entraînent une pollution et contamination des sols.",
          },
          value: 3,
        },
        {
          label: {
            en: 'Minor soil pollution and contamination',
            fr: 'Rare pollution et contamination des solsRare pollution et contamination des sols',
          },
          description: {
            en: 'A small fraction of mineral extraction and processing activities (e.g. mercury amalgamation) lead to soil pollution and contamination',
            fr: "Presque aucune des activités d'extraction et de traitement des minéraux (par exemple, l'amalgamation du mercure) ne conduit à une pollution ou contamination des sols.",
          },
          value: 2,
        },
        {
          label: {
            en: 'No soil pollution and contamination',
            fr: 'Aucune pollution et contamination des sols',
          },
          description: {
            en: 'None of the mineral extraction and processing activities lead to soil pollution and contamination',
            fr: "Aucune des activités d'extraction et de traitement des minéraux n'entraîne de pollution ou contamination des sols.",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: "Pernicious effect on local community health and livelihood and / or its land's environmental sustainability",
            fr: 'Effet néfaste sur la durabilité environnementale et/ou la viabilité économique des terres communautaires',
          },
          value: 5,
        },
        {
          label: {
            en: "Major detrimental effect on local community health and livelihood and / or its land's environmental sustainability",
            fr: 'Effet préjudiciable majeur sur la durabilité environnementale et/ou la viabilité économique des terres communautaires',
          },
          value: 4,
        },
        {
          label: {
            en: "Moderate detrimental effect on local community health and livelihood and / or its land's environmental sustainability",
            fr: 'Effet préjudiciable modéré sur la durabilité environnementale et/ou la viabilité économique des terres communautaires',
          },
          value: 3,
        },
        {
          label: {
            en: "Limited deleterious effect on local community health and livelihood and / or its land's environmental sustainability",
            fr: 'Effet nuisible limité sur la durabilité environnementale et/ou la viabilité économique des terres de la communauté',
          },
          value: 2,
        },
        {
          label: {
            en: "No detrimental effect on local community health and livelihood and / or its land's environmental sustainability",
            fr: 'Aucun effet négatif sur la durabilité environnementale et/ou la viabilité économique des terres communautaires',
          },
          value: 1,
        },
      ],
    },
    airPollution: {
      threat: [
        {
          label: {
            en: 'Pervasive air pollution',
            fr: "Pollution de l'air omniprésente",
          },
          description: {
            en: 'All mineral extraction and processing activities unequivocally lead to air pollution',
            fr: "Toutes les activités d'extraction et de traitement des minéraux entraînent sans équivoque une pollution de l'air.",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread air pollution',
            fr: "Pollution de l'air généralisée",
          },
          description: {
            en: 'Most mineral extraction and processing activities lead to air pollution',
            fr: "La plupart des activités d'extraction et de traitement des minéraux entraînent une pollution de l'air.",
          },
          value: 4,
        },
        {
          label: {
            en: 'Significant air pollution',
            fr: "Pollution de l'air importante",
          },
          description: {
            en: 'Some mineral extraction and processing activities lead to air pollution',
            fr: "Certaines activités d'extraction et de traitement des minéraux entraînent une pollution de l'air.",
          },
          value: 3,
        },
        {
          label: {
            en: 'Minor air pollution',
            fr: 'Rare pollution de lair',
          },
          description: {
            en: 'Almost none of the mineral extraction and processing activities lead to air pollution',
            fr: "Presque aucune des activités d'extraction et de traitement des minéraux ne conduit à une pollution de l'air",
          },
          value: 2,
        },
        {
          label: {
            en: 'No air pollution',
            fr: "Aucune pollution de l'air",
          },
          description: {
            en: 'None of the mineral extraction and processing activities lead to air pollution',
            fr: "Aucune des activités d'extraction et de traitement des minéraux n'entraîne de pollution de l'air.",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious effect on local community health and / or environmental sustainability',
            fr: 'Effet néfaste sur la santé de la communauté locale et/ou la durabilité environnementale',
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on local community health and / or environmental sustainability',
            fr: 'Effet préjudiciable majeur sur la santé de la communauté locale et/ou la durabilité environnementale',
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on local community health and / or environmental sustainability',
            fr: 'Effet nuisible modéré sur la santé de la communauté locale et/ou la durabilité environnementale',
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on local community health and / or environmental sustainability',
            fr: 'Effet délétère limité sur la santé de la communauté locale et / ou la durabilité environnementale',
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on local community health and / or environmental sustainability',
            fr: 'Aucun effet néfaste sur la santé de la communauté locale et/ou la durabilité environnementale',
          },
          value: 1,
        },
      ],
    },
    landslide: {
      threat: [
        {
          label: {
            en: 'Pervasive threat',
            fr: 'Menace omniprésente',
          },
          description: {
            en: 'Mining extraction activities are located in a geographical area systematically subject to landslides (e.g. several landslides have occurred over the past 12 months)',
            fr: "Les activités d'extraction minière sont situées dans une zone géographique systématiquement sujette aux glissements de terrain (par exemple, plusieurs glissements de terrain se sont produits au cours des 12 derniers mois).",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread threat',
            fr: 'Menace fréquente',
          },
          description: {
            en: 'Mining extraction activities are located in a geographical area frequently subject to landslides (e.g. the last landslide incident occurred within the past 12 months)',
            fr: "Les activités d'extraction minière sont situées dans une zone géographique fréquemment sujette aux glissements de terrain (par exemple, le dernier incident de glissement de terrain a eu lieu au cours des 12 derniers mois).",
          },
          value: 4,
        },
        {
          label: {
            en: 'Significant threat',
            fr: 'Menace probable',
          },
          description: {
            en: 'Mining extraction activities are located in a geographical area sometimes subject to landslides (e.g. the last landslide incident occurred 2 years ago)',
            fr: "Les activités d'extraction minière sont situées dans une zone géographique parfois sujette à des glissements de terrain (par exemple, le dernier incident de glissement de terrain s'est produit il y a deux ans).",
          },
          value: 3,
        },
        {
          label: {
            en: 'Minor threat',
            fr: 'Menace potentielle',
          },
          description: {
            en: 'Mining extraction activities are located in a geographical area rarely subject to landslides (e.g. the latest landslide incident dates back 10 years ago)',
            fr: "Les activités d'extraction minière sont situées dans une zone géographique rarement sujette aux glissements de terrain (par exemple, le dernier incident de glissement de terrain remonte à 10 ans).",
          },
          value: 2,
        },
        {
          label: {
            en: 'No threat',
            fr: 'Aucune menace',
          },
          description: {
            en: 'Mining extraction activities are not located in a geographical area subject to landslides',
            fr: "Les activités d'extraction minière ne sont pas situées dans une zone géographique sujette aux glissements de terrain.",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: "Pernicious, far-reaching and life-threatening effect on inviduals' health and security",
            fr: "Effet pernicieux et d'une grande portée sur la santé et la sécurité des individus, pouvant mettre leur vie en danger",
          },
          value: 5,
        },
        {
          label: {
            en: "Major detrimental effect on inviduals' health and security",
            fr: 'Effet préjudiciable majeur sur la santé et la sécurité des individus',
          },
          value: 4,
        },
        {
          label: {
            en: "Moderate detrimental effect on individuals' health and security",
            fr: 'Effet préjudiciable modéré sur la santé et la sécurité des individus',
          },
          value: 3,
        },
        {
          label: {
            en: "Limited deleterious effect on individuals' health and security",
            fr: 'Effet délétère limité sur la santé et la sécurité des individus',
          },
          value: 2,
        },
        {
          label: {
            en: "No detrimental effect on individuals' health and security",
            fr: 'Aucun effet néfaste sur la santé et la sécurité des personnes',
          },
          value: 1,
        },
      ],
    },
    waterFlooding: {
      threat: [
        {
          label: {
            en: 'Pervasive threat',
            fr: 'Menace omniprésente',
          },
          description: {
            en: 'Mining extraction activities are located in a geographical area extremely prone to water flooding (e.g. several floods have occurred over the past 12 months)',
            fr: "Les activités d'extraction minière sont situées dans une zone géographique extrêmement exposée aux inondations (par exemple, plusieurs inondations ont eu lieu au cours des 12 derniers mois).",
          },
          value: 5,
        },
        {
          label: {
            en: 'Frequent threat',
            fr: 'Menace fréquente',
          },
          description: {
            en: 'Mining extraction activities are located in a geographical area frequently subject to water flooding (e.g. the last flood incident occurred within the past 12 months)',
            fr: "Les activités d'extraction minière sont situées dans une zone géographique fréquemment exposée aux inondations (par exemple, la dernière inondation a eu lieu au cours des 12 derniers mois).",
          },
          value: 4,
        },
        {
          label: {
            en: 'Likely threat',
            fr: 'Menace probable',
          },
          description: {
            en: 'Mining extraction activities are located in a geographical area sometimes subject to water flooding (e.g. the last flood incident occurred 2 years ago)',
            fr: "Les activités d'extraction minière sont situées dans une zone géographique parfois soumise à des inondations (par exemple, la dernière inondation a eu lieu il y a deux ans).",
          },
          value: 3,
        },
        {
          label: {
            en: 'Potential threat',
            fr: 'Menace potentielle',
          },
          description: {
            en: 'Mining extraction activities are located in a geographical area rarely subject to water flooding (e.g. the last flood incident occurred 10 years ago)',
            fr: "Les activités d'extraction minière sont situées dans une zone géographique rarement soumise à des inondations (par exemple, la dernière inondation a eu lieu il y a 10 ans).",
          },
          value: 2,
        },
        {
          label: {
            en: 'No threat',
            fr: 'Aucune menace',
          },
          description: {
            en: 'Mining extraction activities are not located in a geographical area subject to water flooding',
            fr: "Les activités d'extraction minière ne sont pas situées dans une zone géographique sujette aux inondations.",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: "Pernicious, far-reaching and life-threatening effect on inviduals' health and security",
            fr: "Effet pernicieux et d'une grande portée sur la santé et la sécurité des individus, pouvant mettre leur vie en danger",
          },
          value: 5,
        },
        {
          label: {
            en: "Major detrimental effect on inviduals' health and security",
            fr: 'Effet préjudiciable majeur sur la santé et la sécurité des individus',
          },
          value: 4,
        },
        {
          label: {
            en: "Moderate detrimental effect on individuals' health and security",
            fr: 'Effet préjudiciable modéré sur la santé et la sécurité des individus',
          },
          value: 3,
        },
        {
          label: {
            en: "Limited deleterious effect on individuals' health and security",
            fr: "Limited deleterious effect on individuals' health and security",
          },
          value: 2,
        },
        {
          label: {
            en: "No detrimental effect on individuals' health and security",
            fr: 'Aucun effet néfaste sur la santé et la sécurité des personnes',
          },
          value: 1,
        },
      ],
    },
    earthquake: {
      threat: [
        {
          label: {
            en: 'Pervasive threat',
            fr: 'Menace omniprésente',
          },
          description: {
            en: 'Mining extraction activities are located in a active earthquake geographical area (e.g. several earthquakes have occurred over the past 12 months)',
            fr: "Les activités d'extraction minière sont situées dans une zone géographique d'activité sismique (par exemple, plusieurs tremblements de terre ont eu lieu au cours des 12 derniers mois).",
          },
          value: 5,
        },
        {
          label: {
            en: 'Frequent threat',
            fr: 'Menace fréquente',
          },
          description: {
            en: 'Mining extraction activities are located in a geographical area frequently subject to earthquakes (e.g. the last earthquake incident occurred within the past 12 months)',
            fr: "Les activités d'extraction minière sont situées dans une zone géographique fréquemment sujette aux tremblements de terre (par exemple, le dernier incident sismique s'est produit au cours des 12 derniers mois).",
          },
          value: 4,
        },
        {
          label: {
            en: 'Likely threat',
            fr: 'Menace probable',
          },
          description: {
            en: 'Mining extraction activities are located in a geographical area sometimes subject to earthquakes (e.g. the last earthquake incident occurred 2 years ago)',
            fr: "Les activités d'extraction minière sont situées dans une zone géographique parfois sujette aux tremblements de terre (par exemple, le dernier tremblement de terre s'est produit il y a deux ans).",
          },
          value: 3,
        },
        {
          label: {
            en: 'Potential threat',
            fr: 'Menace potentielle',
          },
          description: {
            en: 'Mining extraction activities are located in a geographical area rarely subject to earthquakes (e.g. the last earthquake incident occurred 10 years ago)',
            fr: "Les activités d'extraction minière sont situées dans une zone géographique rarement sujette aux tremblements de terre (par exemple, le dernier tremblement de terre a eu lieu il y a 10 ans).",
          },
          value: 2,
        },
        {
          label: {
            en: 'No threat',
            fr: 'Aucune menace',
          },
          description: {
            en: 'Mining extraction activities are not located in a geographical area subject to earthquakes',
            fr: "Les activités d'extraction minière ne sont pas situées dans une zone géographique sujette aux tremblements de terre.",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: "Pernicious, far-reaching and life-threatening effect on inviduals' health and security",
            fr: "Effet pernicieux et d'une grande portée sur la santé et la sécurité des individus, pouvant mettre leur vie en danger",
          },
          value: 5,
        },
        {
          label: {
            en: "Major detrimental effect on inviduals' health and security",
            fr: 'Effet préjudiciable majeur sur la santé et la sécurité des individus',
          },
          value: 4,
        },
        {
          label: {
            en: "Moderate detrimental effect on individuals' health and security",
            fr: 'Effet préjudiciable modéré sur la santé et la sécurité des individus',
          },
          value: 3,
        },
        {
          label: {
            en: "Limited deleterious effect on individuals' health and security",
            fr: 'Effet délétère limité sur la santé et la sécurité des individus',
          },
          value: 2,
        },
        {
          label: {
            en: "No detrimental effect on individuals' health and security",
            fr: 'Aucun effet néfaste sur la santé et la sécurité des personnes',
          },
          value: 1,
        },
      ],
    },
  },
  healthSafety: {
    all: {
      riskScore: [],
    },
    infrastructureReliability: {
      threat: [
        {
          label: {
            en: 'Pervasive infrastructure failure',
            fr: 'Défaillance systématique des infrastructures',
          },
          description: {
            en: 'Mining activity infrastructure (whether at exploration, development, operation and/or closure stages) is systematically subject to incidents (e.g. landslides) due to human errors or omissions and/or product failure, thus severely calling into question its reliability and operational safety.',
            fr: "Les infrastructures de l'activité minière (que ce soit aux stades de l'exploration, du développement, de l'exploitation et/ou de la fermeture) sont systématiquement sujettes à des incidents (par exemple, des glissements de terrain) dus à des erreurs ou omissions humaines et/ou à des défaillances de produits, ce qui remet gravement en question leur fiabilité et leur sécurité opérationnelle.",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread infrastructure failure',
            fr: 'Défaillance généralisée des infrastructures',
          },
          description: {
            en: 'Mining activity infrastructure (whether at exploration, development, operation and/or closure stages) is frequently subject to incidents (e.g. landslides) due to human errors or omissions and/or product failure, thus greatly calling into question its reliability and operational safety.',
            fr: "Les infrastructures de l'activité minière (que ce soit aux stades de l'exploration, du développement, de l'exploitation et/ou de la fermeture) sont fréquemment sujettes à des incidents (par exemple, des glissements de terrain) dus à des erreurs ou omissions humaines et/ou à la défaillance de produits, ce qui remet fortement en question leur fiabilité et leur sécurité opérationnelle.",
          },
          value: 4,
        },
        {
          label: {
            en: 'Large infrastructure failure',
            fr: 'Défaillance importante des infrastructures',
          },
          description: {
            en: 'Mining activity infrastructure (whether at exploration, development, operation and/or closure stages) is sometimes subject to incidents (e.g. landlsides) due to human errors or omissions and/or product failure, thus calling into question its reliability and operational safety.',
            fr: "Les infrastructures de l'activité minière (que ce soit aux stades de l'exploration, du développement, de l'exploitation et/ou de la fermeture) sont parfois sujettes à des incidents (par exemple, des glissements de terrain) dus à des erreurs ou omissions humaines et/ou à la défaillance de produits, ce qui remet en question leur fiabilité et leur sécurité opérationnelle.",
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare infrastructure failure',
            fr: 'Rare défaillance des infrastructures',
          },
          description: {
            en: 'Mining activity infrastructure (whether at exploration, development, operation and/or closure stages) is rarely subject to incidents (e.g. landslides) due to human errors or omissions and/or product failure, which occasionally raises questions about its reliability and operational safety.',
            fr: "Les infrastructures de l'activité minière (que ce soit aux stades de l'exploration, du développement, de l'exploitation et/ou de la fermeture) sont rarement sujettes à des incidents (par exemple, des glissements de terrain) dus à des erreurs ou omissions humaines et/ou à la défaillance d'un produit, ce qui remet occasionnellement en question leur fiabilité et leur sécurité opérationnelle.",
          },
          value: 2,
        },
        {
          label: {
            en: 'No infrastructure failure',
            fr: 'Aucune défaillance des infrastructures',
          },
          description: {
            en: 'Mining activity infrastructure (whether at exploration, development, operation and/or closure stages) is not subject to incidents (e.g. landlsides) caused by human errors or omissions and/or product failure, thereby strengthening its reliability and operational safety.',
            fr: "L'infrastructure de l'activité minière (que ce soit aux stades de l'exploration, du développement, de l'exploitation et/ou de la fermeture) n'est pas sujette à des incidents (par exemple, des glissements de terrain) dus à des erreurs ou omissions humaines et/ou à des défaillances de produits, ce qui renforce sa fiabilité et sa sécurité opérationnelle.",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: "Pernicious, far-reaching and life-threatening effect on individuals' health and safety at work",
            fr: "Effet pernicieux et d'une grande portée sur la santé et la sécurité des individus au travail, pouvant mettre leur vie en danger",
          },
          value: 5,
        },
        {
          label: {
            en: "Major detrimental effect on individuals' health and safety at work",
            fr: 'Effet préjudiciable majeur sur la santé et la sécurité des individus au travail',
          },
          value: 4,
        },
        {
          label: {
            en: "Moderate detrimental effect on individuals' health and safety at work",
            fr: 'Effet préjudiciable modéré sur la santé et la sécurité des individus au travail',
          },
          value: 3,
        },
        {
          label: {
            en: "Limited deleterious effect on individuals' health and safety at work",
            fr: 'Effet délétère limité sur la santé et la sécurité au travail des individus',
          },
          value: 2,
        },
        {
          label: {
            en: "No detrimental effect on individuals' health and safety at work",
            fr: 'Aucun effet préjudiciable sur la santé et la sécurité des individus au travail',
          },
          value: 1,
        },
      ],
      vulnerability: [
        {
          label: {
            en: 'Stakeholders lack awareness of the issue and / or lack the required resources to consider alternatives',
            fr: 'Les parties prenantes ne sont pas conscientes du problème ou ne disposent pas des ressources nécessaires pour envisager des alternatives',
          },
          value: 5,
        },
        {
          label: {
            en: 'Stakeholders are aware of risk but are not able to monitor it',
            fr: 'Les parties prenantes sont conscientes du risque mais ne sont pas en mesure de le contrôler',
          },
          value: 4,
        },
        {
          label: {
            en: 'Stakeholders can monitor but not mitigate risk',
            fr: "Les parties prenantes peuvent surveiller le risque, mais pas l'atténuer",
          },
          value: 3,
        },
        {
          label: {
            en: 'Stakeholders can monitor and mitigate risk but with mixed results',
            fr: 'Les parties prenantes peuvent surveiller et atténuer le risque, mais avec des résultats mitigés',
          },
          value: 2,
        },
        {
          label: {
            en: 'Stakeholders can fully monitor and mitigate risk',
            fr: 'Les parties prenantes peuvent pleinement surveiller et atténuer le risque',
          },
          value: 1,
        },
      ],
    },
    machineReliability: {
      threat: [
        {
          label: {
            en: 'Pervasive machinery failure',
            fr: 'Défaillance systématique des machines',
          },
          description: {
            en: 'Mining activity machinery (whether at exploration, development, operation and/or closure stages) is systematically subject to incidents due to human errors or omissions and/or product failure, thus severely calling into question its reliability and operational safety.',
            fr: "Les machines utilisées dans l'activité minière (que ce soit aux stades de l'exploration, du développement, de l'exploitation et/ou de la fermeture) font systématiquement l'objet d'incidents dus à des erreurs ou omissions humaines et/ou à des défaillances de produits, ce qui remet gravement en question leur fiabilité et leur sécurité opérationnelle.",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread machinery failure',
            fr: 'Défaillance généralisée des machines',
          },
          description: {
            en: 'Mining activity machinery (whether at exploration, development, operation and/or closure stages) is frequently subject to incidents due to human errors or omissions and/or product failure, thus greatly calling into question its reliability and operational safety.',
            fr: "Les machines de l'activité minière (qu'elles soient en phase d'exploration, de développement, d'exploitation et/ou de fermeture) sont fréquemment sujettes à des incidents dus à des erreurs ou omissions humaines et/ou à des défaillances de produits, ce qui remet fortement en question leur fiabilité et leur sécurité opérationnelle.",
          },
          value: 4,
        },
        {
          label: {
            en: 'Large machinery failure',
            fr: 'Défaillance importante des machines',
          },
          description: {
            en: 'Mining activity machinery (whether at exploration, development, operation and/or closure stages) is sometimes subject to incidents due to human errors or omissions and/or product failure, thus calling into question its reliability and operational safety.',
            fr: "Les machines de l'activité minière (qu'elles soient en phase d'exploration, de développement, d'exploitation et/ou de fermeture) sont parfois sujettes à des incidents dus à des erreurs ou omissions humaines et/ou à des défaillances de produits, ce qui remet en question leur fiabilité et leur sécurité opérationnelle.",
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare machinery failure',
            fr: 'Rare défaillance des machines',
          },
          description: {
            en: 'Mining activity machinery (whether at exploration, development, operation and/or closure stages) is rarely subject to incidents due to human errors or omissions and/or product failure, which occasionally raises questions about its reliability and operational safety.',
            fr: "Les machines de l'activité minière (qu'elles soient en phase d'exploration, de développement, d'exploitation et/ou de fermeture) sont rarement sujettes à des incidents dus à des erreurs ou omissions humaines et/ou à des défaillances de produits, ce qui soulève occasionnellement des questions sur leur fiabilité et leur sécurité opérationnelle.",
          },
          value: 2,
        },
        {
          label: {
            en: 'No machinery failure',
            fr: 'Aucune défaillance de machine',
          },
          description: {
            en: 'Mining activity machinery (whether at exploration, development, operation and/or closure stages) is not subject to incidents due to human errors or omissions and/or product failure, thereby strengthening its reliability and operational safety.',
            fr: "Les machines de l'activité minière (qu'elles soient en phase d'exploration, de développement, d'exploitation et/ou de fermeture) ne sont pas sujettes à des incidents dus à des erreurs ou omissions humaines et/ou à des défaillances de produits, ce qui renforce leur fiabilité et leur sécurité opérationnelle.",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: "Pernicious, far-reaching and life-threatening effect on individuals' health and safety at work",
            fr: "Effet pernicieux et d'une grande portée sur la santé et la sécurité des individus au travail, pouvant mettre leur vie en danger",
          },
          value: 5,
        },
        {
          label: {
            en: "Major detrimental effect on individuals' health and safety at work",
            fr: 'Effet préjudiciable majeur sur la santé et la sécurité des individus au travail',
          },
          value: 4,
        },
        {
          label: {
            en: "Moderate detrimental effect on individuals' health and safety at work",
            fr: 'Effet préjudiciable modéré sur la santé et la sécurité des individus au travail',
          },
          value: 3,
        },
        {
          label: {
            en: "Limited deleterious effect on individuals' health and safety at work",
            fr: 'Effet délétère limité sur la santé et la sécurité au travail des individus',
          },
          value: 2,
        },
        {
          label: {
            en: "No detrimental effect on individuals' health and safety at work",
            fr: 'Aucun effet préjudiciable sur la santé et la sécurité des individus au travail',
          },
          value: 1,
        },
      ],
      vulnerability: [
        {
          label: {
            en: 'Stakeholders lack awareness of the issue and / or lack the required resources to consider alternatives',
            fr: 'Les parties prenantes ne sont pas conscientes du problème ou ne disposent pas des ressources nécessaires pour envisager des alternatives',
          },
          value: 5,
        },
        {
          label: {
            en: 'Stakeholders are aware of risk but are not able to monitor it',
            fr: 'Les parties prenantes sont conscientes du risque mais ne sont pas en mesure de le contrôler',
          },
          value: 4,
        },
        {
          label: {
            en: 'Stakeholders can monitor but not mitigate risk',
            fr: "Les parties prenantes peuvent surveiller le risque, mais pas l'atténuer",
          },
          value: 3,
        },
        {
          label: {
            en: 'Stakeholders can monitor and mitigate risk but with mixed results',
            fr: 'Les parties prenantes peuvent surveiller et atténuer le risque, mais avec des résultats mitigés',
          },
          value: 2,
        },
        {
          label: {
            en: 'Stakeholders can fully monitor and mitigate risk',
            fr: 'Les parties prenantes peuvent pleinement surveiller et atténuer le risque',
          },
          value: 1,
        },
      ],
    },
    explosive: {
      threat: [
        {
          label: {
            en: 'Systematic use of explosives and blasting',
            fr: "Utilisation systématique d'explosifs et de dynamitage",
          },
          description: {
            en: 'Explosives and blasting techniques are systematically used across various mining activity stages (exploration, development, operation and/or closure)',
            fr: "Les techniques d'explosifs et de dynamitage sont systématiquement utilisées à différents stades de l'activité minière (exploration, développement, exploitation et/ou fermeture).",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread use of explosives and blasting',
            fr: "Utilisation généralisée d'explosifs et de dynamitage",
          },
          description: {
            en: 'Explosives and blasting techniques are widely used across various mining activity stages (exploration, development, operation and/or closure)',
            fr: "Les explosifs et les techniques de dynamitage sont largement utilisés à différents stades de l'activité minière (exploration, développement, exploitation et/ou fermeture).",
          },
          value: 4,
        },
        {
          label: {
            en: 'Large use of explosives and blasting',
            fr: "Utilisation significative d'explosifs et de dynamitage",
          },
          description: {
            en: 'Explosives and blasting techniques are sometimes used across various mining activity stages (exploration, development, operation and/or closure)',
            fr: "Les explosifs et les techniques de dynamitage sont parfois utilisés à différents stades de l'activité minière (exploration, développement, exploitation et/ou fermeture).",
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare use of explosives and blasting',
            fr: "Utilisation rare d'explosifs et de dynamitage",
          },
          description: {
            en: 'Explosives and blasting techniques are rarely used across various mining activity stages (exploration, development, operation and/or closure)',
            fr: "Les explosifs et les techniques de dynamitage sont rarement utilisés à différents stades de l'activité minière (exploration, développement, exploitation et/ou fermeture).",
          },
          value: 2,
        },
        {
          label: {
            en: 'No use of explosives and blasting',
            fr: "Aucune utilisation d'explosifs et de dynamitage",
          },
          description: {
            en: 'Explosives and blasting techniques are never used at any point in mining activity (exploration, development, operation and/or closure)',
            fr: "Les explosifs et les techniques de dynamitage ne sont jamais utilisés à aucun moment de l'activité minière (exploration, développement, exploitation et/ou fermeture).",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: "Pernicious, far-reaching and life-threatening effect on individuals' health and safety at work",
            fr: "Effet pernicieux et d'une grande portée sur la santé et la sécurité des individus au travail, pouvant mettre leur vie en danger",
          },
          value: 5,
        },
        {
          label: {
            en: "Major detrimental effect on individuals' health and safety at work",
            fr: 'Effet préjudiciable majeur sur la santé et la sécurité des individus au travail',
          },
          value: 4,
        },
        {
          label: {
            en: "Moderate detrimental effect on individuals' health and safety at work",
            fr: 'Effet préjudiciable modéré sur la santé et la sécurité des individus au travail',
          },
          value: 3,
        },
        {
          label: {
            en: "Limited deleterious effect on individuals' health and safety at work",
            fr: 'Effet délétère limité sur la santé et la sécurité au travail des individus',
          },
          value: 2,
        },
        {
          label: {
            en: "No detrimental effect on individuals' health and safety at work",
            fr: 'Aucun effet préjudiciable sur la santé et la sécurité des individus au travail',
          },
          value: 1,
        },
      ],
      vulnerability: [
        {
          label: {
            en: 'Stakeholders lack awareness of the issue and / or lack the required resources to consider alternatives',
            fr: 'Les parties prenantes ne sont pas conscientes du problème ou ne disposent pas des ressources nécessaires pour envisager des alternatives',
          },
          value: 5,
        },
        {
          label: {
            en: 'Stakeholders are aware of risk but are not able to monitor it',
            fr: 'Les parties prenantes sont conscientes du risque mais ne sont pas en mesure de le contrôler',
          },
          value: 4,
        },
        {
          label: {
            en: 'Stakeholders can monitor but not mitigate risk',
            fr: "Les parties prenantes peuvent surveiller le risque, mais pas l'atténuer",
          },
          value: 3,
        },
        {
          label: {
            en: 'Stakeholders can monitor and mitigate risk but with mixed results',
            fr: 'Les parties prenantes peuvent surveiller et atténuer le risque, mais avec des résultats mitigés',
          },
          value: 2,
        },
        {
          label: {
            en: 'Stakeholders can fully monitor and mitigate risk',
            fr: 'Les parties prenantes peuvent pleinement surveiller et atténuer le risque',
          },
          value: 1,
        },
      ],
    },
    mercuryUse: {
      threat: [
        {
          label: {
            en: 'Pervasive use and / or production of mercury',
            fr: 'Utilisation systématique et / ou production de mercure',
          },
          description: {
            en: 'The entire mine ore is amalgamated without any pre-concentration ("whole ore amalgamation")',
            fr: "La totalité du minerai de la mine est amalgamée sans aucune pré-concentration ('amalgamation du minerai entier').",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread use and / or production of mercury',
            fr: 'Utilisation et / ou production généralisée de mercure',
          },
          description: {
            en: 'Most of the mine ore is amalgamated without any pre-concentration',
            fr: 'La majeure partie du minerai de la mine est amalgamée sans pré-concentration.',
          },
          value: 4,
        },
        {
          label: {
            en: 'Large use and / or production of mercury',
            fr: 'Utilisation et / ou production importantes de mercure',
          },
          description: {
            en: 'Some of the mine ore is amalgamated without any pre-concentration',
            fr: 'Une partie du minerai de la mine est amalgamée sans pré-concentration.',
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare use and / or production of mercury',
            fr: 'Utilisation rare et/ou production de mercure',
          },
          description: {
            en: 'A small fragment of the mine ore is amalgamated without any pre-concentration',
            fr: 'Un petit fragment du minerai est amalgamé sans pré-concentration.',
          },
          value: 2,
        },
        {
          label: {
            en: 'No use and / or production of mercury',
            fr: 'Aucune utilisation et / ou production de mercure',
          },
          description: {
            en: 'The mine workforce does not use mercury',
            fr: "La main-d'œuvre de la mine n'utilise pas de mercure.",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: "Pernicious, far-reaching and life-threatening effect on individuals' health and safety at work",
            fr: "Effet pernicieux et d'une grande portée sur la santé et la sécurité des individus au travail, pouvant mettre leur vie en danger",
          },
          description: {
            en: 'Hazardous amalgam burning done without the use of any kind of mercury recovery device',
            fr: "Brûlage des amalgames dangereux sans utilisation d'un quelconque dispositif de récupération du mercure",
          },
          value: 5,
        },
        {
          label: {
            en: "Major detrimental effect on individuals' health and safety at work",
            fr: 'Effet préjudiciable majeur sur la santé et la sécurité des individus au travail',
          },
          description: {
            en: 'Heavy amalgam burning work; the precautionary measures in place to a large extent do not protect the workforce from the most and/or less severe mercury-related health hazards',
            fr: "Travaux lourds de brûlage d'amalgames ; les mesures de précaution mises en place ne protègent pas, dans une large mesure, la main-d'œuvre contre les risques sanitaires les plus et/ou les moins graves liés au mercure.",
          },
          value: 4,
        },
        {
          label: {
            en: "Moderate detrimental effect on individuals' health and safety at work",
            fr: 'Effet préjudiciable modéré sur la santé et la sécurité des individus au travail',
          },
          description: {
            en: 'Light amalgam burning work; the precautionary measures in place can protect the workforce from the most severe mercury-related health hazards, but not from less severe health hazards',
            fr: "Travaux de brûlage d'amalgames légers ; les mesures de précaution en place peuvent protéger la main-d'œuvre contre les risques sanitaires les plus graves liés au mercure, mais pas contre les risques sanitaires moins graves.",
          },
          value: 3,
        },
        {
          label: {
            en: "Limited deleterious effect on individuals' health and safety at work",
            fr: 'Effet délétère limité sur la santé et la sécurité au travail des individus',
          },
          description: {
            en: 'Light and generally secure amalgam burning work; the precautionary measures in place protect the workforce from moderate and severe mercury-related health hazards, but not from some of its secondary effects',
            fr: "Travaux légers et généralement sûrs de brûlage d'amalgames ; les mesures de précaution en place protègent la main-d'œuvre contre les risques modérés et graves pour la santé liés au mercure, mais pas contre certains de ses effets secondaires.",
          },
          value: 2,
        },
        {
          label: {
            en: "No detrimental effect on individuals' health and safety at work",
            fr: 'Aucun effet préjudiciable sur la santé et la sécurité des individus au travail',
          },
          description: {
            en: 'Open burning of amalgam does not take place. Amalgam burning is only done in retorts or under fume hoods equipped with mercury capturing devices.',
            fr: "Le brûlage à l'air libre des amalgames n'a pas lieu. La combustion des amalgames se fait uniquement dans des cornues ou sous des hottes équipées de dispositifs de capture du mercure.",
          },
          value: 1,
        },
      ],
      vulnerability: [
        {
          label: {
            en: 'Stakeholders lack awareness of the issue and / or lack the required resources to consider alternatives',
            fr: 'Les parties prenantes ne sont pas conscientes du problème ou ne disposent pas des ressources nécessaires pour envisager des alternatives',
          },
          value: 5,
        },
        {
          label: {
            en: 'Stakeholders are aware of risk but are not able to monitor it',
            fr: 'Les parties prenantes sont conscientes du risque mais ne sont pas en mesure de le contrôler',
          },
          value: 4,
        },
        {
          label: {
            en: 'Stakeholders can monitor but not mitigate risk',
            fr: "Les parties prenantes peuvent surveiller le risque, mais pas l'atténuer",
          },
          value: 3,
        },
        {
          label: {
            en: 'Stakeholders can monitor and mitigate risk but with mixed results',
            fr: 'Les parties prenantes peuvent surveiller et atténuer le risque, mais avec des résultats mitigés',
          },
          value: 2,
        },
        {
          label: {
            en: 'Stakeholders can fully monitor and mitigate risk',
            fr: 'Les parties prenantes peuvent pleinement surveiller et atténuer le risque',
          },
          value: 1,
        },
      ],
    },
    exposureToHazardous: {
      threat: [
        {
          label: {
            en: 'Pervasive exposure to hazardous substances',
            fr: 'Exposition systématique à des substances dangereuses',
          },
          description: {
            en: '50% or more of the mine workforce is exposed to such elements and/or substances',
            fr: "50% ou plus de la main-d'œuvre de la mine est exposée à de tels éléments et/ou substances.",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread exposure to hazardous substances',
            fr: 'Exposition généralisée à des substances dangereuses',
          },
          description: {
            en: '25-50 % of the mine workforce is exposed to such elements and/or substances',
            fr: '25-50% du personnel de la mine est exposé à de tels éléments et/ou substances.',
          },
          value: 4,
        },
        {
          label: {
            en: 'Large exposure to hazardous substances',
            fr: 'Exposition importante à des substances dangereuses',
          },
          description: {
            en: '10-25% of the mine workforce is exposed to such elements and/or substances',
            fr: "10-25% de la main-d'œuvre de la mine est exposée à de tels éléments et/ou substances.",
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare exposure to hazardous substances',
            fr: 'Rare exposition à des substances dangereuses',
          },
          description: {
            en: '10% or less of the mine workforce is exposed to such elements and/or substances',
            fr: "10% ou moins de la main-d'œuvre de la mine est exposée à de tels éléments et/ou substances.",
          },
          value: 2,
        },
        {
          label: {
            en: 'No exposure to hazardous substances',
            fr: 'Aucune exposition à des substances dangereuses',
          },
          description: {
            en: 'No workforce member is exposed to such elements and /or substances',
            fr: "Aucun membre du personnel n'est exposé à de tels éléments et/ou substances.",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: "Pernicious, far-reaching and life-threatening effect on individuals' health and safety at work",
            fr: "Effet pernicieux et d'une grande portée sur la santé et la sécurité des individus au travail, pouvant mettre leur vie en danger",
          },
          description: {
            en: 'Exposure to hazardous susbtances has devastating health consequences for the workforce',
            fr: "L'exposition à des susbtances dangereuses a des conséquences dévastatrices sur la santé de la main-d'œuvre.",
          },
          value: 5,
        },
        {
          label: {
            en: "Major detrimental effect on individuals' health and safety at work",
            fr: 'Effet préjudiciable majeur sur la santé et la sécurité des individus au travail',
          },
          description: {
            en: 'Exposure to hazardous substances has major health consequences for the workforce',
            fr: "L'exposition à des substances dangereuses a des conséquences majeures sur la santé des travailleurs.",
          },
          value: 4,
        },
        {
          label: {
            en: "Moderate detrimental effect on individuals' health and safety at work",
            fr: 'Effet préjudiciable modéré sur la santé et la sécurité des individus au travail',
          },
          description: {
            en: 'Exposure to hazardous substances has moderate health consequences for the workforce',
            fr: "L'exposition à des substances dangereuses a des conséquences modérées sur la santé des travailleurs.",
          },
          value: 3,
        },
        {
          label: {
            en: "Limited deleterious effect on individuals' health and safety at work",
            fr: 'Effet délétère limité sur la santé et la sécurité au travail des individus',
          },
          description: {
            en: 'Exposure to hazardous substances has minor health consequences for the workforce',
            fr: "L'exposition à des substances dangereuses a des conséquences mineures sur la santé des travailleurs.",
          },
          value: 2,
        },
        {
          label: {
            en: "No detrimental effect on individuals' health and safety at work",
            fr: 'Aucun effet préjudiciable sur la santé et la sécurité des individus au travail',
          },
          description: {
            en: 'Exposure to hazardous substances - if any - has no negative health consequence for the workforce',
            fr: "L'exposition à des substances dangereuses - le cas échéant - n'a aucune conséquence négative sur la santé des travailleurs.",
          },
          value: 1,
        },
      ],
      vulnerability: [
        {
          label: {
            en: 'Stakeholders lack awareness of the issue and / or lack the required resources to consider alternatives',
            fr: 'Les parties prenantes ne sont pas conscientes du problème ou ne disposent pas des ressources nécessaires pour envisager des alternatives',
          },
          value: 5,
        },
        {
          label: {
            en: 'Stakeholders are aware of risk but are not able to monitor it',
            fr: 'Les parties prenantes sont conscientes du risque mais ne sont pas en mesure de le contrôler',
          },
          value: 4,
        },
        {
          label: {
            en: 'Stakeholders can monitor but not mitigate risk',
            fr: "Les parties prenantes peuvent surveiller le risque, mais pas l'atténuer",
          },
          value: 3,
        },
        {
          label: {
            en: 'Stakeholders can monitor and mitigate risk but with mixed results',
            fr: 'Les parties prenantes peuvent surveiller et atténuer le risque, mais avec des résultats mitigés',
          },
          value: 2,
        },
        {
          label: {
            en: 'Stakeholders can fully monitor and mitigate risk',
            fr: 'Les parties prenantes peuvent pleinement surveiller et atténuer le risque',
          },
          value: 1,
        },
      ],
    },
    exposureToRadioactivity: {
      threat: [
        {
          label: {
            en: 'Pervasive exposure to radioactivity',
            fr: 'Exposition systématique à la radioactivité',
          },
          description: {
            en: '50% or more of the mine workforce is exposed to such elements and/or substances',
            fr: "50% ou plus de la main-d'œuvre de la mine est exposée à de tels éléments et/ou substances.",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread exposure to radioactivity',
            fr: 'Exposition généralisée à la radioactivité',
          },
          description: {
            en: '25-50 % of the mine workforce is exposed to such elements and /or substances',
            fr: '25-50% du personnel de la mine est exposé à de tels éléments et/ou substances.',
          },
          value: 4,
        },
        {
          label: {
            en: 'Large exposure to radioactivity',
            fr: 'Exposition importante à la radioactivité',
          },
          description: {
            en: '10-25% of the mine workforce is exposed to such elements and /or substances',
            fr: "10-25% de la main-d'œuvre de la mine est exposée à de tels éléments et/ou substances.",
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare exposure to radioactivity',
            fr: 'Exposition rare à la radioactivité',
          },
          description: {
            en: '10% or less of the mine workforce is exposed to such elements and/or substances',
            fr: "10% ou moins de la main-d'œuvre de la mine est exposée à de tels éléments et/ou substances.",
          },
          value: 2,
        },
        {
          label: {
            en: 'No exposure to radioactivity',
            fr: 'Aucune exposition à la radioactivité',
          },
          description: {
            en: 'No workforce member is exposed to such elements and /or substances',
            fr: "Aucun membre du personnel n'est exposé à de tels éléments et/ou substances.",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: "Pernicious, far-reaching and life-threatening effect on individuals' health and safety at work",
            fr: "Effet pernicieux et d'une grande portée sur la santé et la sécurité des individus au travail, pouvant mettre leur vie en danger",
          },
          description: {
            en: 'Exposure to hazardous susbtances has devastating health consequences for the workforce',
            fr: "L'exposition à des susbtances dangereuses a des conséquences dévastatrices sur la santé de la main-d'œuvre.",
          },
          value: 5,
        },
        {
          label: {
            en: "Major detrimental effect on individuals' health and safety at work",
            fr: 'Effet préjudiciable majeur sur la santé et la sécurité des individus au travail',
          },
          description: {
            en: 'Exposure to hazardous substances has major health consequences for the workforce',
            fr: "L'exposition à des substances dangereuses a des conséquences majeures sur la santé des travailleurs.",
          },
          value: 4,
        },
        {
          label: {
            en: "Moderate detrimental effect on individuals' health and safety at work",
            fr: 'Effet préjudiciable modéré sur la santé et la sécurité des individus au travail',
          },
          description: {
            en: 'Exposure to hazardous substances has moderate health consequences for the workforce',
            fr: "L'exposition à des substances dangereuses a des conséquences modérées sur la santé des travailleurs.",
          },
          value: 3,
        },
        {
          label: {
            en: "Limited deleterious effect on individuals' health and safety at work",
            fr: 'Effet délétère limité sur la santé et la sécurité au travail des individus',
          },
          description: {
            en: 'Exposure to hazardous substances has minor health consequences for the workforce',
            fr: "L'exposition à des substances dangereuses a des conséquences mineures sur la santé des travailleurs.",
          },
          value: 2,
        },
        {
          label: {
            en: "No detrimental effect on individuals' health and safety at work",
            fr: 'Aucun effet préjudiciable sur la santé et la sécurité des individus au travail',
          },
          description: {
            en: 'Exposure to hazardous substances - if any - has no negative health consequence for the workforce',
            fr: "L'exposition à des substances dangereuses - le cas échéant - n'a aucune conséquence négative sur la santé des travailleurs.",
          },
          value: 1,
        },
      ],
      vulnerability: [
        {
          label: {
            en: 'Stakeholders lack awareness of the issue and / or lack the required resources to consider alternatives',
            fr: 'Les parties prenantes ne sont pas conscientes du problème ou ne disposent pas des ressources nécessaires pour envisager des alternatives',
          },
          value: 5,
        },
        {
          label: {
            en: 'Stakeholders are aware of risk but are not able to monitor it',
            fr: 'Les parties prenantes sont conscientes du risque mais ne sont pas en mesure de le contrôler',
          },
          value: 4,
        },
        {
          label: {
            en: 'Stakeholders can monitor but not mitigate risk',
            fr: "Les parties prenantes peuvent surveiller le risque, mais pas l'atténuer",
          },
          value: 3,
        },
        {
          label: {
            en: 'Stakeholders can monitor and mitigate risk but with mixed results',
            fr: 'Les parties prenantes peuvent surveiller et atténuer le risque, mais avec des résultats mitigés',
          },
          value: 2,
        },
        {
          label: {
            en: 'Stakeholders can fully monitor and mitigate risk',
            fr: 'Les parties prenantes peuvent pleinement surveiller et atténuer le risque',
          },
          value: 1,
        },
      ],
    },
    ppe: {
      threat: [
        {
          label: {
            en: 'Worforce systematically does not use PPE',
            fr: "La main-d'œuvre n'utilise pas systématiquement les EPI",
          },
          description: {
            en: '50% or more of the mine workforce is not provided with and/or does not use PPE',
            fr: "50% ou plus du personnel de la mine n'est pas équipé d'EPI et/ou ne les utilise pas",
          },
          value: 5,
        },
        {
          label: {
            en: 'Workforce widely does not use PPE',
            fr: "La main-d'œuvre n'utilise pas généralement les EPI",
          },
          description: {
            en: '25-50% of the mine workforce is not provided with and/or does not use PPE',
            fr: "25-50% du personnel de la mine ne reçoit pas d'EPI et/ou n'en utilise pas",
          },
          value: 4,
        },
        {
          label: {
            en: 'Workforce largely uses PPE',
            fr: "La main-d'œuvre utilise largement les EPI",
          },
          description: {
            en: '10-25% of the mine workforce is not provided with and/or does not use PPE',
            fr: "10-25% des travailleurs de la mine ne reçoivent pas d'EPI et/ou n'en utilisent pas.",
          },
          value: 3,
        },
        {
          label: {
            en: 'Workforce mostly uses PPE',
            fr: "La main-d'œuvre utilise principalement l'EPI",
          },
          description: {
            en: '10% or less of the mine workforce is not provided with and/or does not use PPE',
            fr: "10% ou moins des travailleurs de la mine ne reçoivent pas d'EPI et/ou n'en utilisent pas.",
          },
          value: 2,
        },
        {
          label: {
            en: 'Workforce always uses PPE',
            fr: "La main-d'œuvre utilise toujours l'EPI",
          },
          description: {
            en: 'PPE is made available and compulsory for all mine workforce',
            fr: 'Les EPI sont disponibles et obligatoires pour tous les travailleurs de la mine.',
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: "Pernicious, far-reaching and life-threatening effect on individuals' health and safety at work",
            fr: "Effet pernicieux et d'une grande portée sur la santé et la sécurité des individus au travail, pouvant mettre leur vie en danger",
          },
          description: {
            en: 'Absence of PPE has devastating health consequences for the workforce',
            fr: "L'absence d'EPI a des conséquences dévastatrices sur la santé de la main-d'œuvre.",
          },
          value: 5,
        },
        {
          label: {
            en: "Major detrimental effect on individuals' health and safety at work",
            fr: 'Effet préjudiciable majeur sur la santé et la sécurité des individus au travail',
          },
          description: {
            en: 'Absence of PPE has major health consequences for the workforce',
            fr: "L'absence d'EPI a des conséquences majeures sur la santé des travailleurs.",
          },
          value: 4,
        },
        {
          label: {
            en: "Moderate detrimental effect on individuals' health and safety at work",
            fr: 'Effet préjudiciable modéré sur la santé et la sécurité des individus au travail',
          },
          description: {
            en: 'Absence of PPE has moderate health consequences for the workforce',
            fr: "L'absence d'EPI a des conséquences modérées sur la santé des travailleurs.",
          },
          value: 3,
        },
        {
          label: {
            en: "Limited deleterious effect on individuals' health and safety at work",
            fr: 'Effet délétère limité sur la santé et la sécurité au travail des individus',
          },
          description: {
            en: 'Absence of PPE has minor health consequences for the workforce',
            fr: "L'absence d'EPI a des conséquences mineures sur la santé des travailleurs.",
          },
          value: 2,
        },
        {
          label: {
            en: "No detrimental effect on individuals' health and safety at work",
            fr: 'Aucun effet préjudiciable sur la santé et la sécurité des individus au travail',
          },
          description: {
            en: 'Workforce bears no health consequence from PPE absence (if any)',
            fr: "L'absence d'EPI n'a aucune conséquence sur la santé du personnel (le cas échéant).",
          },
          value: 1,
        },
      ],
      vulnerability: [
        {
          label: {
            en: 'Stakeholders lack awareness of the issue and / or lack the required resources to consider alternatives',
            fr: 'Les parties prenantes ne sont pas conscientes du problème ou ne disposent pas des ressources nécessaires pour envisager des alternatives',
          },
          value: 5,
        },
        {
          label: {
            en: 'Stakeholders are aware of risk but are not able to monitor it',
            fr: 'Les parties prenantes sont conscientes du risque mais ne sont pas en mesure de le contrôler',
          },
          value: 4,
        },
        {
          label: {
            en: 'Stakeholders can monitor but not mitigate risk',
            fr: "Les parties prenantes peuvent surveiller le risque, mais pas l'atténuer",
          },
          value: 3,
        },
        {
          label: {
            en: 'Stakeholders can monitor and mitigate risk but with mixed results',
            fr: 'Les parties prenantes peuvent surveiller et atténuer le risque, mais avec des résultats mitigés',
          },
          value: 2,
        },
        {
          label: {
            en: 'Stakeholders can fully monitor and mitigate risk',
            fr: 'Les parties prenantes peuvent pleinement surveiller et atténuer le risque',
          },
          value: 1,
        },
      ],
    },

  },
  communitySociety: {
    all: {
      riskScore: [],
    },
    localAndMineralActivities: {
      threat: [],
      impact: [],
      vulnerability: [],
    },
    localParticipation: {
      threat: [
        {
          label: {
            en: 'No local participation in decision-making processes',
            fr: 'Aucune participation locale aux processus décisionnels',
          },
          description: {
            en: 'Community is not included, and cannot participate or contribute to decision-making related to mining activity',
            fr: "La communauté n'est pas incluse et ne peut pas participer ou contribuer à la prise de décision concernant l'activité minière.",
          },
          value: 5,
        },
        {
          label: {
            en: 'Very limited local participation in decision-making processes',
            fr: 'Participation locale très limitée aux processus décisionnels',
          },
          description: {
            en: 'Community is partially included, but cannot participate or contribute to decision-making related to mining activity',
            fr: "La communauté est partiellement incluse, mais ne peut pas participer ou contribuer à la prise de décision concernant l'activité minière.",
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate local participation in decision-making processes',
            fr: 'Participation locale modérée aux processus décisionnels',
          },
          description: {
            en: 'Community is included but is rarely invited to participate and contribute to decision-making related to mining activity',
            fr: "La communauté est incluse, mais elle est rarement invitée à participer et à contribuer à la prise de décision concernant l'activité minière.",
          },
          value: 3,
        },
        {
          label: {
            en: 'Significant local participation in decision-making processes',
            fr: 'Participation locale importante aux processus décisionnels',
          },
          description: {
            en: 'Community is included, can generally participate and contribute to decision-making related to mining activity',
            fr: "La communauté est incluse, peut généralement participer et contribuer à la prise de décision concernant l'activité minière",
          },
          value: 2,
        },
        {
          label: {
            en: 'Systematic local participation in decision-making processes',
            fr: 'Participation locale systématique aux processus décisionnels',
          },
          description: {
            en: 'Community is included, can fully participate and contribute to decision-making related to mining activity',
            fr: "La communauté est incluse, peut participer et contribuer pleinement à la prise de décision relative à l'activité minière.",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious tensions between the operator and the community',
            fr: "Tensions pernicieuses entre l'opérateur et la communauté",
          },
          description: {
            en: 'Manifest (acted upon) long-term differences involving non-negotiable issues',
            fr: 'Différends manifestes (auxquels on a donné suite), sur le long terme, et qui concernent des questions non négociables.',
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental tensions between the operator and the community',
            fr: "Tensions néfastes majeures entre l'opérateur et la communauté",
          },
          description: {
            en: 'Latent (not acted upon) long-term differences involving non-negotiable issues',
            fr: 'Différends latents (non traités), sur le long terme, et qui concernent des questions non négociables.',
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental tensions between the operator and the community',
            fr: "Tensions préjudiciables modérées entre l'opérateur et la communauté",
          },
          description: {
            en: 'Manifest (acted upon) short-term disagreements involving negotiable issues',
            fr: 'Désaccords manifestes (auxquels on a donné suite), sur le court terme, et qui concernent des questions négociables.',
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious tensions between the operator and the community',
            fr: "Tensions délétères limitées entre l'opérateur et la communauté",
          },
          description: {
            en: 'Latent (not acted upon) short-term disagreements involving negotiable issues',
            fr: 'Désaccords latents (non traités), sur le court terme, et qui concernent des questions négociables.',
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental tension between the operator and the community',
            fr: "Aucune tension préjudiciable entre l'opérateur et la communauté",
          },
          description: {
            en: 'No latent or manifest, short-term or long-term disagreements involving (non-)negotiable issues',
            fr: 'Aucun désaccord latent ou manifeste, à court ou à long terme, portant sur des questions (non) négociables.',
          },
          value: 1,
        },
      ],
      vulnerability: [
        {
          label: {
            en: 'Stakeholders are not aware that they are entitled to take part in decising-making processes related to mining activities',
            fr: "Les parties prenantes ne savent pas qu'elles ont le droit de prendre part aux processus décisionnels liés aux activités minières",
          },
          value: 5,
        },
        {
          label: {
            en: 'Stakeholders are aware of decision-making processes but lack support to monitor their progress and/or be involved in them',
            fr: 'Les parties prenantes sont au courant des processus de prise de décision mais ne disposent pas du soutien nécessaire pour suivre leur évolution et/ou y être impliquées',
          },
          value: 4,
        },
        {
          label: {
            en: 'Stakeholders can monitor decision-making processes but not mitigate the risk of not being involved in them',
            fr: 'Les parties prenantes peuvent suivre les processus de prise de décision mais ne peuvent pas atténuer le risque de ne pas être impliquées dans ces processus',
          },
          value: 3,
        },
        {
          label: {
            en: 'Stakeholders can monitor decision-making processes and mitigate with mixed results the risk of not being involved in them',
            fr: 'Les parties prenantes peuvent suivre les processus décisionnels et atténuer, avec des résultats mitigés, le risque de ne pas être impliqué dans ces processus',
          },
          value: 2,
        },
        {
          label: {
            en: 'Stakeholders can fully monitor and mitigate the risk of not being involved in decision-making processes related to mining activities',
            fr: 'Les parties prenantes peuvent suivre de près les processus décisionnels et atténuer le risque de ne pas être impliquées dans les processus décisionnels liés aux activités minières',
          },
          value: 1,
        },
      ],
    },
    resourceConflictsForLand: {
      threat: [
        {
          label: {
            en: 'Pervasive resource conflicts regarding land use',
            fr: "Conflits généralisés concernant l'utilisation des terres",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread resource conflicts regarding land use',
            fr: "Conflits étendus concernant l'utilisation des terres",
          },
          value: 4,
        },
        {
          label: {
            en: 'Significant resource conflicts regarding land use',
            fr: "Conflits importants concernant l'utilisation des terres",
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited resource conflicts regarding land use',
            fr: "Conflits limités concernant l'utilisation des terres",
          },
          value: 2,
        },
        {
          label: {
            en: 'No resource conflict regarding land use',
            fr: "Aucun conflit concernant l'utilisation des terres",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious, far-reaching and life-threatening effect on the security and livelihood of individuals',
            fr: "Effet pernicieux, menaçant la vie des individus, et d'une grande portée sur la sécurité et les moyens de subsistance",
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on the security and livelihood of individuals',
            fr: 'Effet préjudiciable majeur sur la sécurité et les moyens de subsistance des individus',
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on the security and livelihood of individuals',
            fr: ' Effet nuisible modéré sur la sécurité et les moyens de subsistance des individus',
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on the security and livelihood of individuals',
            fr: ' Effet délétère limité sur la sécurité et les moyens de subsistance des individus',
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on the security and livelihood of individuals',
            fr: "Aucun effet néfaste sur la sécurité et les moyens d'existence des personnes",
          },
          value: 1,
        },
      ],
      vulnerability: [
        {
          label: {
            en: 'Stakeholders lack awareness of the issue',
            fr: 'Les parties prenantes ne sont pas conscientes du problème',
          },
          value: 5,
        },
        {
          label: {
            en: 'Stakeholders are aware of risk but are not able to monitor it',
            fr: 'Les parties prenantes sont conscientes du risque mais ne sont pas en mesure de le contrôler',
          },
          value: 4,
        },
        {
          label: {
            en: 'Stakeholders can monitor but not mitigate risk',
            fr: "Les parties prenantes peuvent surveiller le risque, mais pas l'atténuer",
          },
          value: 3,
        },
        {
          label: {
            en: 'Stakeholders can monitor and mitigate risk but with mixed results',
            fr: 'Les parties prenantes peuvent surveiller et atténuer le risque, mais avec des résultats mitigés',
          },
          value: 2,
        },
        {
          label: {
            en: 'Stakeholders can fully monitor and mitigate risk',
            fr: 'Les parties prenantes peuvent pleinement surveiller et atténuer le risque',
          },
          value: 1,
        },
      ],
    },
    resourceConflictsForWater: {
      threat: [
        {
          label: {
            en: 'Pervasive resource conflicts regarding water use',
            fr: "Conflits généralisés concernant l'utilisation de l'eau",
          },
          value: 5,
        },
        {
          label: {
            en: 'Widespread resource conflicts regarding water use',
            fr: "Conflits étendus concernant l'utilisation de l'eau",
          },
          value: 4,
        },
        {
          label: {
            en: 'Significant resource conflicts regarding water use',
            fr: "Conflits importants concernant l'utilisation de l'eau",
          },
          value: 3,
        },
        {
          label: {
            en: 'Rare resource conflicts regarding water use',
            fr: "Conflits limités concernant l'utilisation de l'eau",
          },
          value: 2,
        },
        {
          label: {
            en: 'No resource conflicts regarding water use',
            fr: "Aucun conflit concernant l'utilisation de l'eau",
          },
          value: 1,
        },
      ],
      impact: [
        {
          label: {
            en: 'Pernicious, far-reaching and life-threatening effect on the security and livelihood of individuals',
            fr: "Effet pernicieux, menaçant la vie des individus, et d'une grande portée sur la sécurité et les moyens de subsistance",
          },
          value: 5,
        },
        {
          label: {
            en: 'Major detrimental effect on the security and livelihood of individuals',
            fr: 'Effet préjudiciable majeur sur la sécurité et les moyens de subsistance des individus',
          },
          value: 4,
        },
        {
          label: {
            en: 'Moderate detrimental effect on the security and livelihood of individuals',
            fr: 'Effet nuisible modéré sur la sécurité et les moyens de subsistance des individus',
          },
          value: 3,
        },
        {
          label: {
            en: 'Limited deleterious effect on the security and livelihood of individuals',
            fr: 'Effet délétère limité sur la sécurité et les moyens de subsistance des individus',
          },
          value: 2,
        },
        {
          label: {
            en: 'No detrimental effect on the security and livelihood of individuals',
            fr: "Aucun effet néfaste sur la sécurité et les moyens d'existence des personnes",
          },
          value: 1,
        },
      ],
      vulnerability: [
        {
          label: {
            en: 'Stakeholders lack awareness of the issue',
            fr: 'Les parties prenantes ne sont pas conscientes du problème',
          },
          value: 5,
        },
        {
          label: {
            en: 'Stakeholders are aware of risk but are not able to monitor it',
            fr: 'Les parties prenantes sont conscientes du risque mais ne sont pas en mesure de le contrôler',
          },
          value: 4,
        },
        {
          label: {
            en: 'Stakeholders can monitor but not mitigate risk',
            fr: "Les parties prenantes peuvent surveiller le risque, mais pas l'atténuer",
          },
          value: 3,
        },
        {
          label: {
            en: 'Stakeholders can monitor and mitigate risk but with mixed results',
            fr: 'Les parties prenantes peuvent surveiller et atténuer le risque, mais avec des résultats mitigés',
          },
          value: 2,
        },
        {
          label: {
            en: 'Stakeholders can fully monitor and mitigate risk',
            fr: 'Les parties prenantes peuvent pleinement surveiller et atténuer le risque',
          },
          value: 1,
        },
      ],
    },
  },
}
